import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import VideoLoader from "../../components/VideoLoader";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api, { ApiResponse } from "../../services";
import { getCategories } from "../../services/apis";
import vegIcon from "../../assests/Veg_symbol.png";
import nonvegIcon from "../../assests/Non_veg_symbol.png";
import { useOrder, OrderItem, mergeCartIntoOrder } from "../../context/OrderContext";
import Cookies from "js-cookie";
import { AuthModal } from "../../components/SignupSigninModal";
import { useAuth } from "../../context/AuthContext";
import OrderTracker, {
  type OrderTrackerHandle,
} from "../../components/OrderToast";
import { Award, Clock, Gift, ShoppingCart } from "lucide-react";
import { Building2 } from "lucide-react";
import time from "../../assests/time.png";
import loc from "../../assests/loc.png";
import locwhite from "../../assests/locwhite.png";
import { AddressModals, TimePickerModal, type Location } from "./MenuModals";
import { HotelDetailsModal } from "./HotelDetailsModal";
import { useDelivery } from "../../context/DeliveryContext";
import ConfirmModal from "./ConfirmModal";
import { getPlatformLogo } from "../../services/apis";
import {
  getStoreStatusText,
  getTimezoneAbbreviation,
  isRestaurantCurrentlyOpen,
} from "../../lib/utils";
import {
  getSignupLinkData,
  storePendingSignupCode,
  clearPendingSignupCode,
  clearSignupParamsFromUrl,
} from "../../utils/signupLink";
import RepeatCustomModal from "./RepeatcustomModal";
import {
  MenuItem,
  Category,
  AppliedDeal,
  CustomSelectionsWithSections,
} from "./pos.types";
import {
  computeFreeToppingDiscount,
  createSlug,
  isHalfHalfEligibleGroup,
} from "./pos.utils";
import ThemeToggle from "./ThemeToggle";
import CartPanel from "./CartPanel";
import CustomizeModal from "./CustomizeModal";
import DealsModal from "./DealsModal";
import ErrorHandlerPage from "../../components/ErrorHandlerPage";

const POS: React.FC = () => {
  const [selectedCustomizeItem, setSelectedCustomizeItem] =
    useState<MenuItem | null>(null);
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [categories, setCategories] = useState<Category[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<MenuItem | null>(null);
  const [selectedAddress, setselectedAddress] = useState(false);
  const [selectedTimemodal, setselectedTimemodal] = useState(false);
  const [specialRequests, setSpecialRequests] = useState<string>("");
  const [showcustModal, setShowcustModal] = useState(false);
  const {
    orderData,
    setOrderData,
    discount,
    // setDiscount,
    setTotalDealDiscount,
  } = useOrder();
  const [customizingItem, setCustomizingItem] = useState<OrderItem | null>(
    null,
  );
  const [appliedDeals, setAppliedDeals] = useState<AppliedDeal[]>([]);
  const [activeBYODeal, setActiveBYODeal] = useState<{
    claimId: string;
    dealId: string;
    dealName: string;
    basePrice: number;
    includedToppings: number;
    minPizzas: number;
    pizzasDone: number;
    itemIds: string[];
  } | null>(null);
  const [byoPicker, setByoPicker] = useState<{ pizzaIndex: number } | null>(null);
  const [activeBundleDeal, setActiveBundleDeal] = useState<{
    claimId: string;
    dealId: string;
    dealName: string;
    bundlePrice: number;
    fixedItemsTotal: number;
    slots: { options: string[]; preselections: { groupName: string; choiceLabel: string }[] }[];
    currentSlotIndex: number;
    pizzaBasePricesSum: number;
  } | null>(null);
  const [selectedchoice, _setSelectedchoice] = useState<
    "veg" | "non-veg" | null
  >(null);
  const [menuLoading, setMenuLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [authTab, setAuthTab] = useState<"login" | "signup">("login");
  const [lockAuthToSignup, setLockAuthToSignup] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCartHeartbeatActive, setIsCartHeartbeatActive] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window === "undefined") return false;
    const stored = localStorage.getItem("pos_theme");
    if (stored === "dark") return true;
    if (stored === "light") return false;
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });
  const [logoUrl, setLogoUrl] = useState<string>("");
  const [isLogoLoaded, setIsLogoLoaded] = useState(true);
  // True once the logo API call has finished (success or failure), so the
  // "Hey What's up?" fallback isn't shown while the logo is still being fetched.
  const [isLogoFetched, setIsLogoFetched] = useState(false);
  const navigate = useNavigate();
  const cart = orderData?.items || [];
  const [resetSelections, setResetSelections] = useState(0);
  const [stickyStates, setStickyStates] = useState<{ [key: string]: boolean }>(
    {},
  );
  const [confirmModal, setConfirmModal] = useState<{
    open: boolean;
    cartId?: string;
    itemName?: string;
    dealId?: string;
    isDeal?: boolean;
    itemCount?: number;
  }>({ open: false });
  const [clearCartConfirmOpen, setClearCartConfirmOpen] = useState(false);
  const {
    orderType,
    setOrderType,
    pickupLocation,
    pickupTime,
    deliveryAddress,
    deliveryTime,
    setDeliveryAddress,
    setPickupLocation,
    deliveryDate,
    setDeliveryDate,
    pickupDate,
    setPickupDate,
    setPickupTime,
    setDeliveryTime,
    getCurrentRestaurant,
    setPickup,
    updateTaxesForRestaurant,
    delivery,
  } = useDelivery();

  const restaurantLocation = getCurrentRestaurant() as Location | null;

  // Keep orderData.restaurantId in sync with the restaurant currently serving
  // this order (also covers reloads, where the cart can load before/after it).
  const currentRestaurantId = getCurrentRestaurant()?.id;
  useEffect(() => {
    if (!currentRestaurantId) return;
    setOrderData((prev) =>
      prev && prev.restaurantId !== currentRestaurantId
        ? { ...prev, restaurantId: currentRestaurantId }
        : prev,
    );
  }, [currentRestaurantId, orderData?.restaurantId]);

  const [isTimeModalOpen, setIsTimeModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedTime, setSelectedTime] = useState<string>(
    pickupTime || deliveryTime || "",
  );
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const { user, setSquareApplicationId, setSquareLocationId, currencySymbol } = useAuth();
  const heartbeatResetTimerRef = useRef<number | null>(null);
  const heartbeatRafRef = useRef<number | null>(null);
  const hasInitializedCartCountRef = useRef(false);
  const previousCartItemCountRef = useRef(0);

  const triggerCartHeartbeat = useCallback(() => {
    if (heartbeatResetTimerRef.current) {
      window.clearTimeout(heartbeatResetTimerRef.current);
    }
    if (heartbeatRafRef.current) {
      window.cancelAnimationFrame(heartbeatRafRef.current);
    }
    setIsCartHeartbeatActive(false);
    heartbeatRafRef.current = window.requestAnimationFrame(() => {
      setIsCartHeartbeatActive(true);
      heartbeatResetTimerRef.current = window.setTimeout(() => {
        setIsCartHeartbeatActive(false);
      }, 900);
    });
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (isDarkMode) {
      root.classList.add("theme-dark");
    } else {
      root.classList.remove("theme-dark");
    }
    try {
      localStorage.setItem("pos_theme", isDarkMode ? "dark" : "light");
    } catch {
      // Ignore storage errors (e.g., private mode).
    }
  }, [isDarkMode]);

  useEffect(() => {
    if (user?.id) {
      clearPendingSignupCode();
      setLockAuthToSignup(false);
      return;
    }
    const { code, shouldForceSignup } = getSignupLinkData();
    if (!shouldForceSignup) return;
    storePendingSignupCode(code);
    setAuthTab("signup");
    setLockAuthToSignup(true);
    setIsModalOpen(true);
  }, [user?.id]);

  const toggleTheme = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      document.documentElement.style.setProperty("--theme-x", `${x}px`);
      document.documentElement.style.setProperty("--theme-y", `${y}px`);
      const nextDark = !isDarkMode;
      if (!("startViewTransition" in document)) {
        setIsDarkMode(nextDark);
        return;
      }
      (
        document as Document & { startViewTransition: (cb: () => void) => void }
      ).startViewTransition(() => {
        setIsDarkMode(nextDark);
      });
    },
    [isDarkMode],
  );

  const [customSelections, setCustomSelections] =
    useState<CustomSelectionsWithSections>({});
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [isHotelModalOpen, setIsHotelModalOpen] = useState(false);
  const [hasUserConfirmedRestaurant, setHasUserConfirmedRestaurant] =
    useState<boolean>(() => {
      try {
        return sessionStorage.getItem("pos_pickup_confirmed") === "1";
      } catch {
        return false;
      }
    });
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [repeatModalItem, setRepeatModalItem] = useState<MenuItem | null>(null);
  const [pendingItem, setPendingItem] = useState<MenuItem | null>(null);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [collapsedGroups, setCollapsedGroups] = useState<
    Record<string, boolean>
  >({});
  const customizeGroupRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const handleScheduleClick = () => {
    setIsTimeModalOpen(true);
  };

  const getMissingRequiredGroupName = useCallback(() => {
    if (!selectedCustomizeItem) return null;
    const missingRequiredGroup = selectedCustomizeItem.customize.find(
      (group) => {
        if (group.required) {
          return !(group.choices || []).some((choice) => {
            const key = `${group.name}|||${choice.label}`;
            const qty = Number(customSelections[key] || 0);
            return qty > 0;
          });
        }
        const minAddons = group.minAddons ?? 0;
        if (minAddons > 0) {
          const totalSelected = (group.choices || []).reduce((sum, c) => {
            if (c.default) return sum;
            const k = `${group.name}|||${c.label}`;
            return sum + Math.max(0, Number(customSelections[k] || 0));
          }, 0);
          if (totalSelected < minAddons) return true;
        }
        return false;
      },
    );
    return missingRequiredGroup?.name || null;
  }, [selectedCustomizeItem, customSelections]);

  const scrollToMissingRequiredGroup = useCallback(() => {
    const missingGroupName = getMissingRequiredGroupName();
    if (!missingGroupName) return;
    customizeGroupRefs.current[missingGroupName]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }, [getMissingRequiredGroupName]);

  useEffect(() => {
    if (orderData?.scheduledAt) {
      const timezone =
        orderData.scheduledTimezone ||
        restaurantLocation?.timezone ||
        restaurantLocation?._timezoneInfo?.id ||
        "America/Denver";

      const scheduledDate = new Date(orderData.scheduledAt);
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const scheduledDateInTz = new Date(
        scheduledDate.toLocaleString("en-US", { timeZone: timezone }),
      );
      const todayInTz = new Date(
        today.toLocaleString("en-US", { timeZone: timezone }),
      );
      const tomorrowInTz = new Date(
        tomorrow.toLocaleString("en-US", { timeZone: timezone }),
      );

      scheduledDateInTz.setHours(0, 0, 0, 0);
      todayInTz.setHours(0, 0, 0, 0);
      tomorrowInTz.setHours(0, 0, 0, 0);

      let dateString: string;
      if (scheduledDateInTz.getTime() === todayInTz.getTime()) {
        dateString = "today";
      } else if (scheduledDateInTz.getTime() === tomorrowInTz.getTime()) {
        dateString = "tomorrow";
      } else {
        dateString = scheduledDate.toLocaleDateString("en-CA", {
          timeZone: timezone,
        });
      }

      const tzAbbr = getTimezoneAbbreviation(timezone);
      const timeString =
        scheduledDate.toLocaleTimeString("en-US", {
          timeZone: timezone,
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }) +
        " " +
        tzAbbr;

      setSelectedDate(dateString);
      setSelectedTime(timeString);
    }
  }, [
    orderData?.scheduledAt,
    orderData?.scheduledTimezone,
    restaurantLocation,
  ]);

  const getLocationDisplayText = (isMobile = false) => {
    const activeLocation =
      orderType === "pickup" ? pickupLocation : deliveryAddress;

    if (!activeLocation) {
      return orderType === "pickup" ? "Pickup location" : "Delivery address";
    }

    if (isMobile) {
      return activeLocation;
    }

    if (orderType === "pickup") {
      return `Pickup from ${activeLocation}`;
    } else {
      return `Delivering to ${activeLocation}`;
    }
  };

  const getTimeDisplayText = () => {
    if (orderData?.isAsap || selectedTime === "ASAP") {
      const delay = restaurantLocation?.asapDelay;
      return delay && delay > 0 ? `ASAP (est. ${delay} min)` : "ASAP";
    }

    if (selectedDate && selectedTime) {
      let dateLabel = "";
      if (selectedDate === "today") {
        dateLabel = "Today";
      } else if (selectedDate === "tomorrow") {
        dateLabel = "Tomorrow";
      } else {
        const date = new Date(selectedDate);
        dateLabel = date.toLocaleDateString("en-US", { weekday: "short" });
      }
      return `${dateLabel}, ${selectedTime}`;
    }

    return orderType === "pickup" ? "Pickup time" : "Delivery time";
  };

  const getTodayOpeningText = (
    location: any,
    orderType: "pickup" | "delivery",
  ): string => {
    if (!location) return "Closed";
    const timeline =
      orderType === "pickup"
        ? location.pickupTimeline
        : location.deliveryTimeline;
    const timezone =
      location.timezone || location._timezoneInfo?.id || "America/Denver";
    return getStoreStatusText(timeline, timezone);
  };

  const handleChoiceChange = (key: string, newQty: number) => {
    setCustomSelections((prev) => ({
      ...prev,
      [key]: Math.max(newQty, -1),
    }));
  };

  const goToNextCustomizationGroup = useCallback(
    (currentGroupIndex: number) => {
      if (!selectedCustomizeItem) return;
      const nextGroup = selectedCustomizeItem.customize[currentGroupIndex + 1];
      if (!nextGroup) return;

      window.setTimeout(() => {
        const targetEl = customizeGroupRefs.current[nextGroup.name];
        if (!targetEl) return;

        const modalScroller = document.querySelector(
          ".dm-customize-modal",
        ) as HTMLElement | null;

        if (!modalScroller) {
          targetEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
          return;
        }

        const scrollerRect = modalScroller.getBoundingClientRect();
        const targetRect = targetEl.getBoundingClientRect();
        const targetTopInScroller =
          targetRect.top - scrollerRect.top + modalScroller.scrollTop;

        const topOffset = 120;
        modalScroller.scrollTo({
          top: Math.max(0, targetTopInScroller - topOffset),
          behavior: "smooth",
        });
      }, 40);
    },
    [selectedCustomizeItem],
  );

  const handleHalfHalfSelection = (
    choiceKey: string,
    section: "left" | "right" | "whole",
    minQty: number = 1,
  ) => {
    const currentSection =
      (customSelections[`${choiceKey}_section`] as string) || "";
    const currentQuantity = (customSelections[choiceKey] as number) || 0;
    const newSection = currentSection === section ? "" : section;

    setCustomSelections((prev) => ({
      ...prev,
      [`${choiceKey}_section`]: newSection,
      [choiceKey]: newSection ? Math.max(currentQuantity, minQty) : 0,
    }));
  };

  const categoryHeaderRefs = useRef<Record<string, HTMLElement | null>>({});
  const categoryItemRefs = useRef<Record<string, HTMLElement | null>>({});
  const mobileCategoryScrollRef = useRef<HTMLDivElement | null>(null);
  const mobileCategoryItemRefs = useRef<Record<string, HTMLButtonElement | null>>({});
  const sidebarRef = useRef<HTMLDivElement>(null);
  const orderTrackerRef = useRef<OrderTrackerHandle | null>(null);
  const [orderTrackerState, setOrderTrackerState] = useState({
    shouldShow: false,
    isMinimized: false,
    count: 0,
  });

  const handleOrderTrackerStateChange = useCallback(
    (shouldShow: boolean, isMinimized: boolean, count: number) => {
      setOrderTrackerState((prev) => {
        if (
          prev.shouldShow === shouldShow &&
          prev.isMinimized === isMinimized &&
          prev.count === count
        )
          return prev;
        return { shouldShow, isMinimized, count };
      });
    },
    [],
  );

  useEffect(() => {
    if (orderData?.appliedDeals) {
      setAppliedDeals(orderData?.appliedDeals);
    }
  }, [orderData?.appliedDeals]);

  useEffect(() => {
    const callback: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        const el = entry.target as HTMLElement;
        const categoryName = el.getAttribute("data-category-header");
        const isFullyVisible = entry.intersectionRatio >= 0.99;
        const isStuck = !isFullyVisible;
        el.setAttribute("data-top", isStuck.toString());
        if (categoryName) {
          setStickyStates((prev) => ({
            ...prev,
            [categoryName]: isStuck,
          }));
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      threshold: [0.99, 1],
      root: null,
      rootMargin: "0px 0px 0px 0px",
    });

    Object.values(categoryHeaderRefs.current).forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (user) fetchCart();
    if (!user) {
      try {
        const newOrderData = Cookies.get("guest_cart");
        if (newOrderData) {
          const parsedCart = JSON.parse(newOrderData);
          setOrderData((prev) => mergeCartIntoOrder(prev, parsedCart));
        }
      } catch (err) {
        console.error("❌ Failed to parse cart from cookies:", err);
      }
    }
  }, [user]);

  const fetchCart = async () => {
    try {
      const userId = user?.id;
      if (!userId) {
        console.warn("User ID not found — skipping API sync");
        return;
      }

      const response = await api.get(`/cart/getItem`);
      let mergedCart = response.data[0] || {};

      try {
        const guestCart = Cookies.get("guest_cart");
        if (guestCart) {
          const parsedCart = JSON.parse(guestCart);
          const existingItems = response.data[0]?.items || [];
          const guestItems = parsedCart.items || [];

          const itemsMap = new Map();
          existingItems.forEach((item: any) => {
            const key = `${item.itemId}-${JSON.stringify(item.customOptions || [])}`;
            itemsMap.set(key, { ...item });
          });

          guestItems.forEach((guestItem: any) => {
            const key = `${guestItem.itemId}-${JSON.stringify(guestItem.customOptions || [])}`;
            if (itemsMap.has(key)) {
              const existingItem = itemsMap.get(key);
              existingItem.quantity += guestItem.quantity;
            } else {
              itemsMap.set(key, { ...guestItem });
            }
          });

          const mergedItems = Array.from(itemsMap.values());
          mergedCart = { ...response.data[0], items: mergedItems };

          await api.post(`/cart`, { cart: mergedCart });
          Cookies.remove("guest_cart");
        }
      } catch (err) {
        console.error("❌ Failed to parse cart from cookies:", err);
      }

      if (!mergedCart.restaurantId) {
        const restaurant = getCurrentRestaurant();
        if (restaurant) {
          mergedCart = {
            ...mergedCart,
            restaurantId: restaurant.id,
            scheduledTimezone:
              restaurant.timezone ||
              (restaurant as any)._timezoneInfo?.id ||
              "America/Denver",
            ...(orderType === "pickup" && {
              pickupLocation: {
                hotelName: (restaurant as any).hotelName || restaurant.name,
                address: restaurant.address,
                phoneNo: (restaurant as any).phoneNo || "",
                latitude: restaurant.latitude,
                longitude: restaurant.longitude,
              },
              isAsap: pickupTime === "ASAP",
            }),
            ...(orderType === "delivery" &&
              delivery.locationObject && {
                location: {
                  address: delivery.displayAddress,
                  lat: delivery.locationObject.latitude,
                  lng: delivery.locationObject.longitude,
                },
                isAsap: deliveryTime === "ASAP",
              }),
          };
        }
      }

      setOrderData((prev) => mergeCartIntoOrder(prev, mergedCart));
    } catch (error) {
      console.error("❌ Failed to sync cart items:", error);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const itemParam = urlParams.get("item");

    if (itemParam && menuItems.length > 0) {
      const foundItem = menuItems.find((item) => {
        const itemSlug = createSlug(item.name);
        return itemSlug === itemParam;
      });

      if (foundItem) {
        setSelectedCustomizeItem(foundItem);
        setCustomizingItem(null);
        setShowcustModal(true);
      }
    }
  }, [menuItems]);

  useEffect(() => {
    const handlePopState = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const itemParam = urlParams.get("item");

      if (itemParam && menuItems.length > 0) {
        const foundItem = menuItems.find((item) => {
          const itemSlug = createSlug(item.name);
          return itemSlug === itemParam;
        });

        if (foundItem) {
          setSelectedCustomizeItem(foundItem);
          setCustomizingItem(null);
          setShowcustModal(true);
        }
      } else {
        setShowcustModal(false);
        setSelectedCustomizeItem(null);
        setCustomSelections({});
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [menuItems]);

  const menuRef = useRef<HTMLDivElement>(null);
  const categorySectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {},
  );
  const isManualScrolling = useRef(false);
  const scrollTimeout = useRef<NodeJS.Timeout | null>(null);
  const manualScrollTarget = useRef<string | null>(null);
  const manualScrollSafetyTimeout = useRef<NodeJS.Timeout | null>(null);
  const manualScrollListenerRef = useRef<(() => void) | null>(null);

  // Category names an item is listed under: its primary category plus any additional ones
  const getItemCategoryNames = useCallback(
    (item: MenuItem): string[] => {
      const names = new Set<string>();
      if (item.category && item.category.trim() !== "") names.add(item.category);
      (item.additionalCategoryIds || []).forEach((id) => {
        const cat = categories.find((c) => c._id === id);
        if (cat) names.add(cat.name);
      });
      return Array.from(names);
    },
    [categories],
  );

  const groupedMenuItems = useMemo(() => {
    const grouped: { [key: string]: MenuItem[] } = {};

    menuItems.forEach((item) => {
      getItemCategoryNames(item).forEach((categoryName) => {
        if (!grouped[categoryName]) {
          grouped[categoryName] = [];
        }
        grouped[categoryName].push(item);
      });
    });

    const sortedGrouped: { [key: string]: MenuItem[] } = {};
    categories.forEach((cat) => {
      if (grouped[cat.name]) {
        sortedGrouped[cat.name] = grouped[cat.name];
      }
    });

    Object.keys(grouped).forEach((cat) => {
      if (!sortedGrouped[cat]) {
        sortedGrouped[cat] = grouped[cat];
      }
    });

    return sortedGrouped;
  }, [menuItems, categories, getItemCategoryNames]);

  useEffect(() => {
    const menuElement = menuRef.current;
    if (!menuElement) return;

    const categoryNames = Object.keys(groupedMenuItems);
    if (categoryNames.length === 0) return;

    const stickyHeaderOffset = 120;
    let rafId: number | null = null;

    const updateActiveCategory = () => {
      if (!menuRef.current || isManualScrolling.current) return;

      const menuRect = menuRef.current.getBoundingClientRect();
      const anchorY = menuRect.top + stickyHeaderOffset;
      let activeCategory = categoryNames[0];

      for (const categoryName of categoryNames) {
        const sectionElement = categorySectionRefs.current[categoryName];
        if (!sectionElement) continue;

        const sectionTop = sectionElement.getBoundingClientRect().top;
        if (sectionTop <= anchorY) {
          activeCategory = categoryName;
        } else {
          break;
        }
      }

      setSelectedCategory((prev) =>
        prev === activeCategory ? prev : activeCategory,
      );
    };

    const handleScroll = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        updateActiveCategory();
      });
    };

    updateActiveCategory();
    menuElement.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      menuElement.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
    };
  }, [groupedMenuItems]);

  const handleCategorySelect = (categoryName: string) => {
    const sectionElement = categorySectionRefs.current[categoryName];

    if (sectionElement && menuRef.current) {
      const menuElement = menuRef.current;

      const releaseManualScrollLock = () => {
        isManualScrolling.current = false;
        manualScrollTarget.current = null;

        if (scrollTimeout.current) {
          clearTimeout(scrollTimeout.current);
          scrollTimeout.current = null;
        }
        if (manualScrollSafetyTimeout.current) {
          clearTimeout(manualScrollSafetyTimeout.current);
          manualScrollSafetyTimeout.current = null;
        }
        if (manualScrollListenerRef.current && menuRef.current) {
          menuRef.current.removeEventListener(
            "scroll",
            manualScrollListenerRef.current,
          );
          manualScrollListenerRef.current = null;
        }
      };

      if (manualScrollListenerRef.current) {
        menuElement.removeEventListener(
          "scroll",
          manualScrollListenerRef.current,
        );
        manualScrollListenerRef.current = null;
      }

      const menuTop = menuElement.getBoundingClientRect().top;
      const sectionTop = sectionElement.getBoundingClientRect().top;
      const scrollTop = sectionTop - menuTop + menuElement.scrollTop;

      isManualScrolling.current = true;
      manualScrollTarget.current = categoryName;

      menuElement.scrollTo({ top: scrollTop, behavior: "smooth" });

      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      if (manualScrollSafetyTimeout.current)
        clearTimeout(manualScrollSafetyTimeout.current);

      const handleProgrammaticScroll = () => {
        if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
        scrollTimeout.current = setTimeout(() => {
          releaseManualScrollLock();
        }, 180);
      };

      manualScrollListenerRef.current = handleProgrammaticScroll;
      menuElement.addEventListener("scroll", handleProgrammaticScroll, {
        passive: true,
      });
      handleProgrammaticScroll();

      manualScrollSafetyTimeout.current = setTimeout(() => {
        releaseManualScrollLock();
      }, 5000);
    }

    setSelectedCategory(categoryName);
  };

  useEffect(() => {
    if (!selectedCategory || !sidebarRef.current) return;

    const selectedCategoryElement = categoryItemRefs.current[selectedCategory];
    const sidebar = sidebarRef.current;

    if (selectedCategoryElement && sidebar) {
      const sidebarRect = sidebar.getBoundingClientRect();
      const categoryRect = selectedCategoryElement.getBoundingClientRect();

      const isAboveView = categoryRect.top < sidebarRect.top;
      const isBelowView = categoryRect.bottom > sidebarRect.bottom;

      if (isAboveView || isBelowView) {
        const categoryOffsetTop = selectedCategoryElement.offsetTop;
        const sidebarHeight = sidebar.clientHeight;
        const categoryHeight = selectedCategoryElement.clientHeight;

        const scrollTo =
          categoryOffsetTop - sidebarHeight / 2 + categoryHeight / 2;

        sidebar.scrollTo({ top: scrollTo, behavior: "smooth" });
      }
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (!selectedCategory || typeof window === "undefined") return;
    if (window.innerWidth >= 640) return;

    const mobileCategoryScroll = mobileCategoryScrollRef.current;
    const activeCategoryChip = mobileCategoryItemRefs.current[selectedCategory];
    if (!mobileCategoryScroll || !activeCategoryChip) return;

    const targetScrollLeft =
      activeCategoryChip.offsetLeft -
      mobileCategoryScroll.clientWidth / 2 +
      activeCategoryChip.clientWidth / 2;

    mobileCategoryScroll.scrollTo({
      left: Math.max(0, targetScrollLeft),
      behavior: "smooth",
    });
  }, [selectedCategory]);

  useEffect(() => {
    if (!selectedCustomizeItem || customizingItem) return;

    const defaults: Record<string, number> = {};
    const defaultSections: Record<string, string> = {};
    const isHalfHalfPizza = selectedCustomizeItem.category
      ?.toLowerCase()
      .includes("pizza");

    selectedCustomizeItem.customize.forEach((group: any) => {
      const defaultChoices = (group.choices || []).filter(
        (c: any) => c.default,
      );
      defaultChoices.forEach((defaultChoice: any) => {
        const key = `${group.name}|||${defaultChoice.label}`;
        defaults[key] = 1;
        if (isHalfHalfEligibleGroup(group, Boolean(isHalfHalfPizza))) {
          defaultSections[`${key}_section`] = "whole";
        }
      });
    });

    // For bundle deals, apply slot preselections — these override item defaults
    // for their groups so the deal-included choice shows as selected on open.
    if (activeBundleDeal) {
      const slot = activeBundleDeal.slots[activeBundleDeal.currentSlotIndex];
      if (slot?.preselections?.length) {
        slot.preselections.forEach(
          (p: { groupName: string; choiceLabel: string }) => {
            const groupPrefix = `${p.groupName}|||`;
            // Clear any item-default already set for this group
            Object.keys(defaults).forEach((k) => {
              if (k.startsWith(groupPrefix)) defaults[k] = 0;
            });
            defaults[`${p.groupName}|||${p.choiceLabel}`] = 1;
          },
        );
      }
    }

    setCustomSelections({ ...defaults, ...defaultSections });
  }, [selectedCustomizeItem, resetSelections, activeBundleDeal]);

  useEffect(() => {
    if (!selectedCustomizeItem || !showcustModal) return;
    const isHalfHalfPizza = selectedCustomizeItem.category
      ?.toLowerCase()
      .includes("pizza");
    if (!isHalfHalfPizza) return;

    setCustomSelections((prev) => {
      let changed = false;
      const next = { ...prev };

      selectedCustomizeItem.customize.forEach((group: any) => {
        if (!isHalfHalfEligibleGroup(group, isHalfHalfPizza)) return;
        group.choices.forEach((choice: any) => {
          const key = `${group.name}|||${choice.label}`;
          const qty = (prev[key] as number) ?? 0;
          const sectionKey = `${key}_section`;
          const section = (prev[sectionKey] as string) || "";

          if (qty === 0 && !section) {
            next[sectionKey] = "whole";
            changed = true;
          }
        });
      });

      return changed ? next : prev;
    });
  }, [selectedCustomizeItem, showcustModal]);

  const buildSelectionsFromOptions = (
    menuItem: MenuItem | undefined,
    options: {
      label: string;
      price: number;
      qty: number;
      isDefault?: boolean;
      groupName?: string;
    }[] = [],
  ) => {
    if (!menuItem || !Array.isArray(options)) return {};
    const map: Record<string, number | string> = {};

    const isHalfHalfPizza =
      menuItem.category?.toLowerCase().includes("pizza") ||
      menuItem.customize.some((grp: any) => grp.portionOptions);

    options.forEach((opt) => {
      let choiceLabel = opt.label;
      let section = "";

      if (isHalfHalfPizza) {
        const sections = ["left", "right", "whole"];
        const foundSection = sections.find((s) =>
          opt.label.toLowerCase().endsWith(` ${s}`),
        );

        if (foundSection) {
          section = foundSection;
          choiceLabel = opt.label
            .replace(new RegExp(` ${foundSection}$`, "i"), "")
            .trim();
        }
      }

      const matchingGroups = menuItem.customize.filter((g) =>
        g.choices.some((c) => c.label === choiceLabel),
      );
      let group =
        (opt.groupName
          ? matchingGroups.find((g) => g.name === opt.groupName)
          : undefined) || null;

      if (!group) {
        group =
          matchingGroups.find((g) => {
            if (g.multiple) return true;
            const groupPrefix = `${g.name}|||`;
            return !Object.keys(map).some(
              (existingKey) =>
                !existingKey.endsWith("_section") &&
                existingKey.startsWith(groupPrefix),
            );
          }) || matchingGroups[0];
      }

      if (group) {
        const key = `${group.name}|||${choiceLabel}`;
        map[key] = opt.qty;

        if (isHalfHalfPizza && section) {
          map[`${key}_section`] = section;
        } else if (
          isHalfHalfPizza &&
          isHalfHalfEligibleGroup(group, true) &&
          opt.qty > 0
        ) {
          map[`${key}_section`] = "whole";
        }
      }
    });

    return map;
  };

  const getDisplayAddedOptions = (cartItem: any) => {
    const options = cartItem?.customOptions || [];
    if (!Array.isArray(options) || options.length === 0) return [];

    const menuItem = menuItems.find((m) => m._id === cartItem.itemId);

    return options
      .map((opt: any) => {
        const rawQty = Number(opt?.qty || 0);
        if (rawQty <= 0) return null;

        const baseLabel = String(opt?.label || "")
          .replace(/\s+(left|right|whole)$/i, "")
          .trim();

        const matchedChoice = menuItem?.customize
          ?.flatMap((group) => group.choices || [])
          ?.find((choice) => choice.label === baseLabel);

        const isDefaultChoice = Boolean(
          opt?.isDefault ?? matchedChoice?.default,
        );
        const displayQty = isDefaultChoice ? Math.max(0, rawQty - 1) : rawQty;

        if (displayQty <= 0) return null;
        return { label: String(opt?.label || ""), qty: displayQty };
      })
      .filter((opt): opt is { label: string; qty: number } => opt !== null);
  };

  useEffect(() => {
    if (!isCartOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsCartOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isCartOpen]);

  const toggleCart = () => setIsCartOpen((v) => !v);
  const closeCart = () => setIsCartOpen(false);

  const totalItems = useMemo(
    () => cart.reduce((t, i) => t + i.quantity, 0),
    [cart],
  );

  useEffect(() => {
    if (!hasInitializedCartCountRef.current) {
      hasInitializedCartCountRef.current = true;
      previousCartItemCountRef.current = totalItems;
      return;
    }

    if (totalItems > previousCartItemCountRef.current) {
      triggerCartHeartbeat();
    }
    previousCartItemCountRef.current = totalItems;
  }, [totalItems, triggerCartHeartbeat]);

  useEffect(() => {
    return () => {
      if (heartbeatResetTimerRef.current) {
        window.clearTimeout(heartbeatResetTimerRef.current);
      }
      if (heartbeatRafRef.current) {
        window.cancelAnimationFrame(heartbeatRafRef.current);
      }
    };
  }, []);

  const subtotal = useMemo(() => {
    return cart.reduce((total, item) => {
      if (!item.isPartOfDeal) {
        return total + item.price * item.quantity;
      }
      return total + (item.originalPrice || item.price) * item.quantity;
    }, 0);
  }, [cart]);

  const discountAmount = useMemo(
    () => (subtotal * (discount ?? 0)) / 100,
    [subtotal, discount],
  );

  const removeDealFromCart = (dealId: string) => {
    const newCart = cart.filter((item) => item.dealId !== dealId);
    const newDeals = appliedDeals.filter((deal) => deal.dealId !== dealId);

    setOrderData((prev) => ({
      ...prev,
      items: newCart,
      appliedDeals: newDeals,
    }));

    toast.success("Deal removed from cart");
  };

  const totalDealDiscount = useMemo(() => {
    // BYO deal discounts are already baked into the item's finalPrice, so exclude them here
    return appliedDeals
      .filter((d) => d.dealType !== 'build_your_own')
      .reduce((sum, deal) => sum + deal.discountAmount, 0);
  }, [appliedDeals]);

  const grandTotal = useMemo(() => {
    let total = subtotal;
    total -= totalDealDiscount;
    total -= discountAmount;
    return Math.max(0, total);
  }, [subtotal, totalDealDiscount, discountAmount]);

  useEffect(() => {
    setTotalDealDiscount(totalDealDiscount);
  }, [totalDealDiscount]);

  const handleCustomSubmit = useCallback(async () => {
    if (!selectedCustomizeItem) return;
    const isHalfHalfPizza =
      selectedCustomizeItem.category?.toLowerCase().includes("pizza") ||
      selectedCustomizeItem.customize.some((grp) => grp.portionOptions);

    if (getMissingRequiredGroupName()) return;

    const bundleLockedKeys = new Set<string>(
      activeBundleDeal
        ? (activeBundleDeal.slots[activeBundleDeal.currentSlotIndex]?.preselections || []).map(
            (p) => `${p.groupName}|||${p.choiceLabel}`
          )
        : []
    );

    let extraPrice = 0;
    const selectedOptions = selectedCustomizeItem.customize.flatMap((group) =>
      group.choices
        .map((choice) => {
          const key = `${group.name}|||${choice.label}`;
          const qty = (customSelections[key] as number) || 0;
          const section = customSelections[`${key}_section`] as string;

          if (qty === -1 || qty > 0) {
            const label =
              isHalfHalfPizza && section
                ? `${choice.label} ${section}`
                : choice.label;

            const unitPrice = choice.price || 0;
            const isLockedChoice = bundleLockedKeys.has(key);
            const chargeableQty =
              qty > 0 && (choice.default || isLockedChoice)
                ? Math.max(0, qty - 1)
                : Math.max(0, qty);
            extraPrice += unitPrice * chargeableQty;

            return {
              label,
              price: unitPrice,
              qty,
              isDefault: Boolean(choice.default),
              groupName: group.name,
            };
          }
          return null;
        })
        .filter(
          (
            c,
          ): c is {
            label: string;
            price: number;
            qty: number;
            isDefault: boolean;
            groupName: string;
          } => c !== null,
        ),
    );

    const freeToppingDiscount = computeFreeToppingDiscount(
      selectedCustomizeItem,
      customSelections,
    );
    extraPrice = Math.max(0, extraPrice - freeToppingDiscount);

    let newCart: OrderItem[];

    // ── BUNDLE mode ──
    if (activeBundleDeal) {
      const pizzaFinalPrice = selectedCustomizeItem.price + extraPrice;
      const bundleCartItem: OrderItem = {
        itemId: selectedCustomizeItem._id,
        name: selectedCustomizeItem.name,
        kitchenName: selectedCustomizeItem.kitchenName,
        price: pizzaFinalPrice,
        categoryId: selectedCustomizeItem.categoryId ?? "",
        tax: 0,
        cartId: Date.now().toString() + Math.random().toString(36).substring(2, 9),
        quantity: 1,
        imageUrl: selectedCustomizeItem.imageUrl,
        customOptions: selectedOptions,
        dealId: activeBundleDeal.claimId,
        isPartOfDeal: true,
      };
      newCart = [...cart, bundleCartItem];

      const newBasePricesSum = activeBundleDeal.pizzaBasePricesSum + selectedCustomizeItem.price;
      const isLastSlot = activeBundleDeal.currentSlotIndex === activeBundleDeal.slots.length - 1;

      setResetSelections((c) => c + 1);
      setCustomSelections({});

      if (isLastSlot) {
        const finalDiscount = newBasePricesSum + activeBundleDeal.fixedItemsTotal - activeBundleDeal.bundlePrice;
        setShowcustModal(false);
        setOrderData((prev) => ({
          ...prev,
          items: newCart,
          appliedDeals: (prev?.appliedDeals || []).map((d) =>
            d.claimId === activeBundleDeal.claimId
              ? { ...d, discountAmount: Number(finalDiscount.toFixed(2)) }
              : d,
          ),
        }));
        setActiveBundleDeal(null);
        setSelectedCustomizeItem(null);
      } else {
        const nextSlotIndex = activeBundleDeal.currentSlotIndex + 1;
        const nextSlot = activeBundleDeal.slots[nextSlotIndex];
        const nextItem = menuItems.find((m) => m._id === nextSlot.options[0]);
        setOrderData((prev) => ({ ...prev, items: newCart }));
        setActiveBundleDeal((prev) =>
          prev ? { ...prev, currentSlotIndex: nextSlotIndex, pizzaBasePricesSum: newBasePricesSum } : null
        );
        if (nextItem) {
          setShowcustModal(false);
          setTimeout(() => {
            setSelectedCustomizeItem(nextItem);
            setResetSelections((c) => c + 1);
            setShowcustModal(true);
          }, 120);
        } else {
          // Item not found — roll back
          setOrderData((prev) => ({
            ...prev,
            items: (prev?.items || []).filter((i) => i.dealId !== activeBundleDeal.claimId),
            appliedDeals: (prev?.appliedDeals || []).filter((d) => d.claimId !== activeBundleDeal.claimId),
          }));
          setActiveBundleDeal(null);
          toast.error("Bundle item not found. Please try again.");
        }
      }
      return;
    }

    // ── BUILD YOUR OWN mode ──
    if (activeBYODeal) {
      const included = activeBYODeal.includedToppings;
      let byoExtraPrice = 0;
      const byoOptions = selectedOptions.map((opt) => {
        byoExtraPrice += (opt.price || 0) * Math.max(0, opt.qty);
        return opt;
      });
      // Apply BYO free toppings discount
      let freeRemaining = included;
      let byoFreeToppingDiscount = 0;
      for (const group of selectedCustomizeItem.customize) {
        if (group.required || group.multiple || freeRemaining <= 0) continue;
        for (const choice of group.choices) {
          if (freeRemaining <= 0) break;
          if (choice.default) continue;
          const key = `${group.name}|||${choice.label}`;
          const qty = Number((customSelections as Record<string, number>)[key] || 0);
          if (qty > 0) {
            const freeQty = Math.min(qty, freeRemaining);
            byoFreeToppingDiscount += (choice.price || 0) * freeQty;
            freeRemaining -= freeQty;
          }
        }
      }
      byoExtraPrice = Math.max(0, byoExtraPrice - byoFreeToppingDiscount);
      const finalPrice = activeBYODeal.basePrice + byoExtraPrice;

      const byoCartItem: OrderItem = {
        itemId: selectedCustomizeItem._id,
        name: selectedCustomizeItem.name,
        kitchenName: selectedCustomizeItem.kitchenName,
        price: finalPrice,
        categoryId: selectedCustomizeItem.categoryId ?? "",
        tax: 0,
        cartId: Date.now().toString() + Math.random().toString(36).substring(2, 9),
        quantity: 1,
        imageUrl: selectedCustomizeItem.imageUrl,
        customOptions: byoOptions,
        dealId: activeBYODeal.claimId,
        isPartOfDeal: true,
      };

      newCart = [...cart, byoCartItem];
      const nextPizzasDone = activeBYODeal.pizzasDone + 1;

      setResetSelections((c) => c + 1);
      setOrderData((prev) => ({
        ...prev,
        items: newCart,
        appliedDeals: (prev?.appliedDeals || []).map((d) =>
          d.claimId === activeBYODeal.claimId
            ? { ...d, discountAmount: Number(((d.discountAmount || 0) + byoFreeToppingDiscount).toFixed(2)) }
            : d
        ),
      }));
      setCustomSelections({});
      setShowcustModal(false);

      if (nextPizzasDone < activeBYODeal.minPizzas) {
        setActiveBYODeal({ ...activeBYODeal, pizzasDone: nextPizzasDone });
        if (activeBYODeal.itemIds.length > 1) {
          setTimeout(() => setByoPicker({ pizzaIndex: nextPizzasDone }), 300);
        } else {
          setTimeout(() => {
            const sameItem = menuItems.find((m) => m._id === activeBYODeal.itemIds[0]) ?? selectedCustomizeItem;
            setSelectedCustomizeItem(sameItem);
            setShowcustModal(true);
          }, 300);
        }
      } else {
        setActiveBYODeal(null);
        setSelectedCustomizeItem(null);
      }
      return;
    }

    if (customizingItem) {
      newCart = cart.map((c) =>
        c.cartId === customizingItem.cartId
          ? {
              ...c,
              price: selectedCustomizeItem.price + extraPrice,
              customOptions: selectedOptions,
              requestedCustomization: specialRequests,
            }
          : c,
      );
    } else {
      const existing = cart.find(
        (c) =>
          c.itemId === selectedCustomizeItem._id &&
          JSON.stringify(c.customOptions) === JSON.stringify(selectedOptions),
      );

      if (existing) {
        newCart = cart.map((c) =>
          c.cartId === existing.cartId ? { ...c, quantity: c.quantity + 1 } : c,
        );
      } else {
        const resolvedCategoryCode =
          selectedCustomizeItem?.categoryCode ??
          categories.find(
            (cat) => cat._id === selectedCustomizeItem?.categoryId,
          )?.categoryCode;

        newCart = [
          ...cart,
          {
            itemId: selectedCustomizeItem._id,
            name: selectedCustomizeItem.name,
            kitchenName: selectedCustomizeItem.kitchenName,
            price: selectedCustomizeItem.price + extraPrice,
            requestedCustomization: specialRequests,
            cartId:
              Date.now().toString() +
              Math.random().toString(36).substring(2, 9),
            quantity: 1,
            imageUrl: selectedCustomizeItem.imageUrl,
            customOptions: selectedOptions,
            prepTime: selectedCustomizeItem.prepTime,
            categoryId:
              resolvedCategoryCode ?? selectedCustomizeItem?.categoryId ?? "",
          },
        ];
      }
    }

    setSpecialRequests("");
    setResetSelections((c) => c + 1);
    setOrderData((prev) => ({ ...prev, items: newCart }));
    setShowcustModal(false);
    setCustomSelections({});
    setCustomizingItem(null);
    setSelectedCustomizeItem(null);
  }, [
    selectedCustomizeItem,
    customizingItem,
    customSelections,
    getMissingRequiredGroupName,
    cart,
    specialRequests,
    setOrderData,
    setResetSelections,
    setShowcustModal,
    setCustomSelections,
    setCustomizingItem,
    activeBYODeal,
    activeBundleDeal,
    menuItems,
  ]);

  const syncToDB = async () => {
    try {
      const userId = user?.id;
      if (!userId) {
        try {
          Cookies.set("guest_cart", JSON.stringify(orderData), {
            expires: 7,
            path: "/",
          });
        } catch (err) {
          console.error("❌ Failed to save cart to cookies:", err);
        }
        return;
      }

      await api.post(`/cart`, { cart: orderData });
    } catch (error) {
      console.error("❌ Failed to sync custom cart item:", error);
    }
  };

  useEffect(() => {
    syncToDB();
  }, [orderData?.items]);

  useEffect(() => {
    const hasLocation =
      orderType === "pickup"
        ? Boolean(pickupLocation)
        : Boolean(deliveryAddress);
    const hasTime =
      orderType === "pickup"
        ? Boolean(pickupDate && pickupTime)
        : Boolean(deliveryDate && deliveryTime);
    setselectedAddress(hasLocation);
    setselectedTimemodal(hasTime);

    const activeTime = orderType === "pickup" ? pickupTime : deliveryTime;
    const activeDate = orderType === "pickup" ? pickupDate : deliveryDate;
    setSelectedTime(activeTime || "");
    setSelectedDate(activeDate || null);

    fetchCategoriesData();
    fetchAndAutoSelectPickupLocation();
  }, []);

  const fetchAndAutoSelectPickupLocation = async () => {
    try {
      if (orderType !== "pickup") return;
      if (pickupLocation) {
        setselectedAddress(true);
        setselectedTimemodal(Boolean(pickupDate && pickupTime));
        return;
      }

      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/get-hotel-info`,
      );

      if (!res.data?.success) return;

      const hotels = res.data.data;

      if (hotels.length >= 1) {
        const haversineDistance = (
          lat1: number,
          lon1: number,
          lat2: number,
          lon2: number,
        ) => {
          const R = 6371;
          const dLat = ((lat2 - lat1) * Math.PI) / 180;
          const dLon = ((lon2 - lon1) * Math.PI) / 180;
          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos((lat1 * Math.PI) / 180) *
              Math.cos((lat2 * Math.PI) / 180) *
              Math.sin(dLon / 2) ** 2;
          return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        };

        let hotel = hotels[0];
        try {
          let permState = "prompt";
          if (navigator.permissions) {
            const perm = await navigator.permissions.query({
              name: "geolocation",
            });
            permState = perm.state;
          }

          if (permState !== "denied") {
            const opts: PositionOptions =
              permState === "granted"
                ? { maximumAge: 300000, timeout: 8000 }
                : { maximumAge: 300000 };

            const position = await new Promise<GeolocationPosition>(
              (resolve, reject) =>
                navigator.geolocation.getCurrentPosition(resolve, reject, opts),
            );
            const { latitude: userLat, longitude: userLng } = position.coords;
            hotel = hotels.reduce((nearest: any, h: any) => {
              const dNearest = haversineDistance(
                userLat,
                userLng,
                nearest.latitude,
                nearest.longitude,
              );
              const dH = haversineDistance(
                userLat,
                userLng,
                h.latitude,
                h.longitude,
              );
              return dH < dNearest ? h : nearest;
            }, hotels[0]);
          }
        } catch {
          // Location denied or unavailable — keep hotels[0]
        }

        const locationObject = {
          id: hotel._id,
          hotelName: hotel.hotelName,
          name: hotel.hotelName,
          address: hotel.address,
          latitude: hotel.latitude,
          longitude: hotel.longitude,
          country: hotel.country,
          state: hotel.state,
          city: hotel.city,
          phoneNo: hotel.phoneNo,
          pickupTimeline: hotel.pickupTimeline,
          deliveryTimeline: hotel.deliveryTimeline,
          storeTimeline: hotel.storeTimeline,
          defaultTip: hotel.defaultTip,
          timezone: hotel.timezone,
          _timezoneInfo: hotel._timezoneInfo,
          _storeStatus: hotel._storeStatus,
          deliveryTipToPartner: hotel.deliveryTipToPartner,
          baseTipPercent: hotel.baseTipPercent,
          tipGapPercent: hotel.tipGapPercent,
          withinRadius: hotel.withinRadius,
          minOrderAmount: hotel.minOrderAmount,
          deliveryAmount: hotel.deliveryAmount,
          asapDelay: hotel.asapDelay,
          taxPercentage: hotel.taxes,
          cashEnabled: hotel.cashEnabled,
        };
        updateTaxesForRestaurant(hotel._id, hotel.taxes || []);

        setPickup((prev: any) => ({
          ...prev,
          displayAddress: hotel.address,
          locationObject,
        }));

        setPickupLocation(hotel.address);
        setSelectedLocation(hotel.hotelName);
        setselectedAddress(true);

        // Update Square credentials for the auto-selected hotel
        const squareIntegration = hotel.integrations?.square;
        if (squareIntegration?.configured && squareIntegration?.credentials) {
          setSquareApplicationId(
            squareIntegration.credentials.SQUARE_APPLICATION_ID || null,
          );
          setSquareLocationId(
            squareIntegration.credentials.SQUARE_LOCATION_ID || null,
          );
        } else {
          setSquareApplicationId(null);
          setSquareLocationId(null);
        }

        const isOpen = isRestaurantCurrentlyOpen(locationObject, "pickup");

        setOrderData((prev) => ({
          ...prev,
          restaurantId: hotel._id,
          pickupLocation: {
            hotelName: hotel.hotelName,
            address: hotel.address,
            phoneNo: hotel.phoneNo || "",
            latitude: hotel.latitude,
            longitude: hotel.longitude,
          },
          isAsap: isOpen,
          scheduledTimezone:
            hotel.timezone || hotel._timezoneInfo?.id || "America/Denver",
        }));

        if (isOpen) {
          setPickupTime("ASAP");
          setPickupDate("today");
          setselectedTimemodal(true);
        }
        if (pickupLocation) {
          setselectedAddress(true);
          setselectedTimemodal(Boolean(pickupDate && pickupTime));
          setOrderData((prev) => ({
            ...prev,
            restaurantId: hotel._id,
            pickupLocation: {
              hotelName: hotel.hotelName,
              address: hotel.address,
              phoneNo: hotel.phoneNo || "",
              latitude: hotel.latitude,
              longitude: hotel.longitude,
            },
            scheduledTimezone:
              hotel.timezone || hotel._timezoneInfo?.id || "America/Denver",
          }));
          return;
        }
      }
    } catch (err) {
      console.error("Failed to fetch pickup locations on load:", err);
    }
  };

  const fetchMenuItems = async (
    foodType?: string | null,
    restaurantId?: string | null,
    silent = false,
  ) => {
    try {
      if (!silent) setMenuLoading(true);
      setError(null);

      let url = "/menu";
      const params: string[] = [];
      if (foodType) params.push(`foodType=${encodeURIComponent(foodType)}`);
      if (restaurantId)
        params.push(`restaurantId=${encodeURIComponent(restaurantId)}`);
      if (orderType) params.push(`orderType=${orderType}`);
      if (params.length > 0) url += `?${params.join("&")}`;

      const { data } = await api.get<ApiResponse<MenuItem[]>>(url);
      if (data.success && Array.isArray(data.data)) {
        setMenuItems(data.data);
      } else {
        setMenuItems([]);
        setError("Failed to load menu.");
      }
    } catch {
      setMenuItems([]);
      setError("Failed to load menu.");
    } finally {
      setMenuLoading(false);
      setLoading(false);
    }
  };

  const isInitialMount = useRef(true);
  useEffect(() => {
    const silent = !isInitialMount.current;
    fetchMenuItems(selectedchoice, restaurantLocation?.id, silent);
    isInitialMount.current = false;
  }, [selectedchoice, restaurantLocation?.id, orderType]);

  const fetchCategoriesData = async () => {
    try {
      const res = await getCategories();
      if (res.data.success) {
        const cats: Category[] = res.data.data.map(
          (cat: {
            name: string;
            imageUrl: string;
            categoryCode: string;
            _id: string;
          }) => ({
            name: cat.name,
            imageUrl: cat.imageUrl,
            categoryCode: cat.categoryCode,
            _id: cat._id,
          }),
        );
        setCategories(cats);
        if (!selectedCategory && cats.length > 0) {
          setSelectedCategory(cats[0].name);
        }
      }
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
  };

  const resolveCategoryCode = useCallback(
    (item: { categoryCode?: string; categoryId?: string }) =>
      item.categoryCode ??
      categories.find((cat) => cat._id === item.categoryId)?.categoryCode,
    [categories],
  );

  const handleAddToCart = useCallback(
    async (item: MenuItem) => {
      try {
        const existing = cart.find(
          (c) =>
            c.itemId === item._id &&
            (!c.customOptions || c.customOptions.length === 0),
        );

        let newCart: OrderItem[];

        if (existing) {
          newCart = cart.map((c) =>
            c.cartId === existing.cartId
              ? { ...c, quantity: c.quantity + 1 }
              : c,
          );
        } else {
          newCart = [
            ...cart,
            {
              itemId: item._id,
              name: item.name,
              kitchenName: item.kitchenName,
              price: item.price,
              cartId:
                Date.now().toString() +
                Math.random().toString(36).substring(2, 9),
              quantity: 1,
              imageUrl: item.imageUrl,
              prepTime: item.prepTime,
              customOptions: [],
              categoryId: resolveCategoryCode(item) ?? item.categoryId ?? "",
            },
          ];
        }

        setOrderData((prev) => {
          const mappedItems = newCart.map((item) => ({
            ...item,
            dealId: item.dealId,
            prepTime: item.prepTime,
            isPartOfDeal: item.isPartOfDeal,
            originalPrice: item.originalPrice,
          }));
          if (!prev) {
            const restaurant = getCurrentRestaurant();
            return {
              items: mappedItems,
              ...(restaurant && {
                restaurantId: restaurant.id,
                scheduledTimezone:
                  restaurant.timezone ||
                  (restaurant as any)._timezoneInfo?.id ||
                  "America/Denver",
                isAsap: pickupTime === "ASAP",
              }),
            };
          }
          return { ...prev, items: mappedItems };
        });

        const userId = localStorage.getItem("userId");
        const payload = {
          userId,
          itemId: item._id,
          name: item.name,
          kitchenName: item.kitchenName,
          quantity: existing ? existing.quantity + 1 : 1,
          price: item.price,
          customOptions: [],
        };
        if (!userId) {
          try {
            Cookies.set("guest_cart", JSON.stringify(payload), {
              expires: 7,
              path: "/",
            });
          } catch (err) {
            console.error("❌ Failed to save cart to cookies:", err);
          }
          return;
        }

        await api.post("/cart", payload);
      } catch (error) {
        console.error("❌ Failed to add item to cart:", error);
      }
    },
    [cart, setOrderData, resolveCategoryCode],
  );

  const removeFromCart = (cartId: string) => {
    const item = cart.find((c) => c.cartId === cartId);

    if (item?.isPartOfDeal && item.dealId) {
      setConfirmModal({
        open: true,
        cartId,
        itemName: item.name,
        dealId: item.dealId,
        isDeal: true,
      });
      return;
    }

    setConfirmModal({
      open: true,
      cartId,
      itemName: item?.name,
      isDeal: false,
    });
  };

  const getLogo = async () => {
    try {
      const response = await getPlatformLogo();
      if (response.data.success) {
        setIsLogoLoaded(false);
        setLogoUrl(response.data.logo);
      } else {
        setLogoUrl("");
        setIsLogoLoaded(true);
      }
    } catch (error) {
      // Logo is non-critical; keep app usable when backend is unavailable.
      console.error("Failed to fetch platform logo:", error);
      setLogoUrl("");
      setIsLogoLoaded(true);
    } finally {
      setIsLogoFetched(true);
    }
  };

  useEffect(() => {
    getLogo();
    // Safety net: never block the page on a slow logo API.
    const t = setTimeout(() => setIsLogoFetched(true), 5000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!logoUrl) {
      setIsLogoLoaded(true);
      return;
    }

    let isActive = true;
    setIsLogoLoaded(false);

    const img = new Image();
    img.src = logoUrl;
    img.onload = () => {
      if (isActive) setIsLogoLoaded(true);
    };
    img.onerror = () => {
      if (isActive) {
        setLogoUrl("");
        setIsLogoLoaded(true);
      }
    };

    return () => {
      isActive = false;
    };
  }, [logoUrl]);

  const handleConfirmRemove = () => {
    if (confirmModal.isDeal && confirmModal.dealId) {
      removeDealFromCart(confirmModal.dealId);
    } else if (confirmModal.cartId) {
      const newCart = cart.filter((c) => c.cartId !== confirmModal.cartId);
      setOrderData((prev) => ({ ...prev, items: newCart }));
    }
    setConfirmModal({ open: false });
  };

  const updateQuantity = (cartId: string, quantity: number) => {
    const item = cart.find((c) => c.cartId === cartId);

    if (item?.isPartOfDeal) {
      toast.error(
        "Cannot modify quantity of deal items. Remove the entire deal instead.",
      );
      return;
    }

    if (quantity < 1) return removeFromCart(cartId);

    const newCart = cart.map((c) =>
      c.cartId === cartId ? { ...c, quantity } : c,
    );
    setOrderData((prev) => ({ ...prev, items: newCart }));
  };

  const getItemQty = useCallback(
    (cartId: string) => cart.find((c) => c.cartId === cartId)?.quantity ?? 0,
    [cart],
  );

  // User-level discount (user.discount) disabled for now — uncomment to re-enable.
  // useEffect(() => {
  //   setDiscount(user?.discount ?? 0);
  // }, [user?.discount]);

  useEffect(() => {
    if (orderType === "pickup") {
      setselectedAddress(Boolean(pickupLocation));
      setselectedTimemodal(Boolean(pickupDate && pickupTime));
      return;
    }
    setselectedAddress(Boolean(deliveryAddress));
    setselectedTimemodal(Boolean(deliveryDate && deliveryTime));
  }, [
    orderType,
    pickupLocation,
    pickupDate,
    pickupTime,
    deliveryAddress,
    deliveryDate,
    deliveryTime,
  ]);

  const markPickupConfirmed = useCallback(() => {
    setHasUserConfirmedRestaurant(true);
    try {
      sessionStorage.setItem("pos_pickup_confirmed", "1");
    } catch {}
  }, []);

  const handleCheckout = async () => {
    if (cart.length === 0) {
      toast.error("Cart is empty");
      return;
    }

    if (orderType === "delivery") {
      if (!selectedAddress || !deliveryAddress) {
        setIsAddressModalOpen(true);
        return;
      }
      if (!selectedTimemodal || !deliveryDate || !deliveryTime) {
        setIsTimeModalOpen(true);
        return;
      }
    }

    if (orderType === "pickup") {
      if (!selectedAddress || !pickupLocation || !hasUserConfirmedRestaurant) {
        setIsAddressModalOpen(true);
        return;
      }
      if (!selectedTimemodal || !pickupDate || !pickupTime) {
        setIsTimeModalOpen(true);
        return;
      }
    }

    setLoading(true);
    try {
      if (orderType === "pickup" && pickupLocation) {
        markPickupConfirmed();
      }
      navigate("/checkout");
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const itemHasCustomizations = (item: MenuItem) => {
    return (
      Array.isArray(item.customize) &&
      item.customize.some(
        (group: any) =>
          Array.isArray(group?.choices) && group.choices.length > 0,
      )
    );
  };
function containsDrink(input: string): boolean {
  if (!input) return false;

  return /\bdrinks?\b/i.test(input);
}
  const handleMenuItemSelect = (item: MenuItem) => {
    if (orderType === "delivery" && !deliveryAddress) {
      setPendingItem(item);
      setIsAddressModalOpen(true);
      return;
    }
    if (
      orderType === "pickup" &&
      (!pickupLocation || !hasUserConfirmedRestaurant)
    ) {
      setPendingItem(item);
      setIsAddressModalOpen(true);
      return;
    }
    if (orderType === "delivery" && !deliveryTime) {
      setPendingItem(item);
      setIsTimeModalOpen(true);
      return;
    }
    if (orderType === "pickup" && !pickupTime) {
      setPendingItem(item);
      setIsTimeModalOpen(true);
      return;
    }
    handlecust(item);
  };

  const handleAddButtonClick = (item: MenuItem, e: React.MouseEvent) => {
    e.stopPropagation();

    if (orderType === "delivery" && !deliveryAddress) {
      setPendingItem(item);
      setIsAddressModalOpen(true);
      return;
    }
    if (
      orderType === "pickup" &&
      (!pickupLocation || !hasUserConfirmedRestaurant)
    ) {
      setPendingItem(item);
      setIsAddressModalOpen(true);
      return;
    }
    if (orderType === "delivery" && !deliveryTime) {
      setPendingItem(item);
      setIsTimeModalOpen(true);
      return;
    }
    if (orderType === "pickup" && !pickupTime) {
      setPendingItem(item);
      setIsTimeModalOpen(true);
      return;
    }

    const isCustomizable = itemHasCustomizations(item);

    if (isCustomizable) {
      const existingItems = cart.filter((c) => c.itemId === item._id);

      if (existingItems.length > 0) {
        setRepeatModalItem(item);
        setShowRepeatModal(true);
        return;
      }
    }

    handlecust(item);
  };

  useEffect(() => {
    if (!isAddressModalOpen && !isTimeModalOpen && pendingItem) {
      const locationSelected =
        orderType === "delivery" ? deliveryAddress : pickupLocation;
      const timeSelected =
        orderType === "delivery"
          ? deliveryDate && deliveryTime
          : pickupDate && pickupTime;

      if (locationSelected && timeSelected) {
        const isCustomizable = itemHasCustomizations(pendingItem);

        if (isCustomizable) {
          const existingItems = cart.filter(
            (c) => c.itemId === pendingItem._id,
          );
          if (existingItems.length > 0) {
            setRepeatModalItem(pendingItem);
            setShowRepeatModal(true);
          } else {
            handlecust(pendingItem);
          }
        } else {
          handlecust(pendingItem);
        }
        setPendingItem(null);
      }
    }
  }, [
    isAddressModalOpen,
    isTimeModalOpen,
    pendingItem,
    deliveryAddress,
    pickupLocation,
    deliveryDate,
    deliveryTime,
    pickupDate,
    pickupTime,
    orderType,
  ]);

  const handleRepeatOrder = (cartItem: OrderItem) => {
    updateQuantity(cartItem.cartId, cartItem.quantity + 1);
  };

  const handlecust = (item: MenuItem) => {
    setSelectedCustomizeItem(item);
    setCustomizingItem(null);
    setShowcustModal(true);

    const itemSlug = createSlug(item.name);
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("item", itemSlug);
    window.history.pushState({}, "", currentUrl.toString());
  };

  const closeCustomizeModal = () => {
    // Cancel any active deal flows when the modal is dismissed
    if (activeBundleDeal) {
      setOrderData((prev) => ({
        ...prev,
        items: (prev?.items || []).filter((i) => i.dealId !== activeBundleDeal.claimId),
        appliedDeals: (prev?.appliedDeals || []).filter((d) => d.claimId !== activeBundleDeal.claimId),
      }));
      setActiveBundleDeal(null);
    }
    if (activeBYODeal) {
      setOrderData((prev) => ({
        ...prev,
        items: (prev?.items || []).filter((i) => i.dealId !== activeBYODeal.claimId),
        appliedDeals: (prev?.appliedDeals || []).filter((d) => d.claimId !== activeBYODeal.claimId),
      }));
      setActiveBYODeal(null);
    }
    setByoPicker(null);
    setShowcustModal(false);
    setResetSelections((c) => c + 1);
    setCustomSelections({});
    setAttemptedSubmit(false);
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("item");
    window.history.pushState({}, "", currentUrl.toString());
  };

  // Called when customer claims a Build Your Own deal from DealsModal
  const handleByoDealClaim = (deal: {
    _id: string;
    name: string;
    basePrice?: number;
    includedToppings?: number;
    minPizzas?: number;
    items: { itemId: string | { _id: string } }[];
  }) => {
    const itemIds = deal.items.map((i) =>
      typeof i.itemId === "object" ? (i.itemId as { _id: string })._id : (i.itemId as string)
    );
    if (itemIds.length === 0) return;

    const minPizzas = deal.minPizzas ?? itemIds.length;
    const claimId = Date.now().toString() + Math.random().toString(36).substring(2, 7);

    setCustomizingItem(null);
    setActiveBYODeal({
      claimId,
      dealId: deal._id,
      dealName: deal.name,
      basePrice: deal.basePrice ?? 0,
      includedToppings: deal.includedToppings ?? 0,
      minPizzas,
      pizzasDone: 0,
      itemIds,
    });

    setOrderData((prev) => ({
      ...prev,
      appliedDeals: [
        ...(prev?.appliedDeals || []),
        {
          dealId: deal._id,
          claimId,
          originalDealId: deal._id,
          name: deal.name,
          discountAmount: 0,
          dealType: "build_your_own" as const,
          byoBasePrice: deal.basePrice ?? 0,
          byoIncludedToppings: deal.includedToppings ?? 0,
        },
      ],
    }));

    if (itemIds.length > 1) {
      setByoPicker({ pizzaIndex: 0 });
    } else {
      const baseItem = menuItems.find((m) => m._id === itemIds[0]);
      if (baseItem) {
        setSelectedCustomizeItem(baseItem);
        setShowcustModal(true);
      }
    }
  };

  const switchBundleOption = (itemId: string) => {
    const item = menuItems.find((m) => m._id === itemId);
    if (item) {
      setSelectedCustomizeItem(item);
      setResetSelections((c) => c + 1);
    }
  };

  // Called when customer claims a Bundle deal from DealsModal
  const handleBundleDealClaim = (
    deal: {
      _id: string;
      name: string;
      bundlePrice?: number;
      items: { itemId: string | { _id: string } }[];
    },
    fixedItemsTotal: number,
    fixedCartItems: OrderItem[],
    slots: { options: string[]; preselections: { groupName: string; choiceLabel: string }[] }[],
  ) => {
    if (slots.length === 0) {
      toast.error("This bundle has no customizable slots configured.");
      return;
    }

    const bundlePrice = deal.bundlePrice ?? 0;
    const claimId = Date.now().toString() + Math.random().toString(36).substring(2, 7);
    const taggedFixedItems = fixedCartItems.map((item) => ({ ...item, dealId: claimId }));

    setCustomizingItem(null);
    setActiveBundleDeal({
      claimId,
      dealId: deal._id,
      dealName: deal.name,
      bundlePrice,
      fixedItemsTotal,
      slots,
      currentSlotIndex: 0,
      pizzaBasePricesSum: 0,
    });

    setOrderData((prev) => ({
      ...prev,
      items: [...(prev?.items || []), ...taggedFixedItems],
      appliedDeals: [
        ...(prev?.appliedDeals || []),
        {
          dealId: deal._id,
          claimId,
          originalDealId: deal._id,
          name: deal.name,
          discountAmount: 0,
          dealType: "bundle" as const,
          bundlePrice,
        },
      ],
    }));

    const firstItem = menuItems.find((m) => m._id === slots[0].options[0]);
    if (!firstItem) {
      setOrderData((prev) => ({
        ...prev,
        items: (prev?.items || []).filter((i) => i.dealId !== claimId),
        appliedDeals: (prev?.appliedDeals || []).filter((d) => d.claimId !== claimId),
      }));
      setActiveBundleDeal(null);
      toast.error("Bundle item not found. Please try again.");
      return;
    }
    setSelectedCustomizeItem(firstItem);
    setShowcustModal(true);
  };

  const showLogo = Boolean(logoUrl);
  const missingRequiredGroupName = getMissingRequiredGroupName();
  const isPageLoading =
    loading || !isLogoFetched || (showLogo && !isLogoLoaded);
  const isRecoveringMenu = menuLoading && menuItems.length === 0;
  const showFullPageLoader = isPageLoading || isRecoveringMenu;
  const hasNoMenuItems =
    !menuLoading && !loading && Object.keys(groupedMenuItems).length === 0;
  const shouldShowMenuErrorPage = Boolean(error) || hasNoMenuItems;

  if (showFullPageLoader) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <VideoLoader size="medium" />
      </div>
    );
  }

  if (shouldShowMenuErrorPage) {
    return (
      <ErrorHandlerPage
        title={error ? "Something Went Wrong!" : "No Items Available"}
        description={
          error
            ? "We are unable to load at the moment. Please try again."
            : "No menu items are currently available. Please check back soon."
        }
        retryLabel="Reload"
        showHomeButton={false}
        onRetry={() =>
          fetchMenuItems(selectedchoice, restaurantLocation?.id || null)
        }
      />
    );
  }

  return (
    <div className="flex h-screen bg-white">
      {/* Sidebar */}
      <div
        className="hidden sm:flex w-[100px] sm:w-[100px] md:w-[200px] lg:w-[230px] relative
    border-r border-black/5 flex-col
    py-3 sm:py-4 md:py-6 px-2 sm:px-2.5 md:px-3 gap-4 sm:gap-5 md:gap-7
    pb-0 no-scrollbar"
        style={{ maxHeight: "100vh" }}
      >
        <div className=" flex items-center justify-center">
          {!showLogo && (
            <div
              className={showLogo ? "opacity-0 select-none" : ""}
              aria-hidden={showLogo}
            >
              <h2 className="font-bold text-black dark:text-white text-[16px] sm:text-[19px] md:text-[22px] lg:text-[26px] mb-0 leading-tight">
                Hey
              </h2>
              <span className="font-light text-[16px] text-black dark:text-white sm:text-[19px] md:text-[22px] lg:text-[26px] leading-tight">
                What's up?
              </span>
            </div>
          )}
          {showLogo ? (
            <img
              src={logoUrl}
              alt="Platform logo"
              className="w-auto h-[105px] object-contain"
            />
          ) : null}
        </div>

        <div
          ref={sidebarRef}
          className="menu-list mb-[65px] w-full overflow-y-auto custom-scrollbar no-scrollbar overflow-x-hidden pb-[40px] md:pb-[70px]"
        >
          <ul className="flex flex-col gap-[8px] sm:gap-[10px] p-0 mb-16">
            {categories.map((category) => (
              <li
                ref={(el) => {
                  categoryItemRefs.current[category.name] = el;
                }}
                className={`sidebar-item flex flex-col rounded-[10px] overflow-x-auto items-start py-[8px] sm:py-[10px] md:py-[12px]
      px-[8px] sm:px-[12px] md:px-[15px] cursor-pointer transition-transform font-semibold
      text-[9px] sm:text-[10px] md:text-[12px] lg:text-[13px] xl:text-[15px]
      hover:scale-103 will-change-transform gap-2 sm:gap-3 ${
        selectedCategory === category.name
          ? isDarkMode
            ? "dm-white-btn sidebar-item--selected"
            : "bg-main/90 text-white sidebar-item--selected"
          : "hover:text-black/90 text-black/80"
      }`}
                key={category.name}
                onClick={() => handleCategorySelect(category.name)}
              >
                <div className="font-semibold 2xl:text-[15px] lg:text-[13px] sm:text-[13px] text-[13px] leading-normal">
                  {category.name}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="menu-list absolute bottom-1 left-0 right-0 w-full no-scrollbar">
          <div className=" flex-shrink-0  p-2 sm:p-3 md:p-4 space-y-2">
        {/* <DealsModal onByoDealClaim={handleByoDealClaim} onBundleDealClaim={handleBundleDealClaim}/> */}
            {user ? (
              <>
                {orderTrackerState.shouldShow &&
                  orderTrackerState.isMinimized && (
                    <div className="flex flex-col rounded-[30px] items-center cursor-pointer transition font-semibold 2xl:text-[15px] lg:text-[13px] sm:text-[12px] text-xs gap-2">
                      <button
                        onClick={() => orderTrackerRef.current?.handleShow()}
                        className="dm-recent-order-btn w-full flex items-center justify-center gap-1.5 sm:gap-2
                          rounded-lg px-1 sm:px-3 py-1 sm:py-2.5
                          dm-white-btn bg-black text-[#ffffff] font-semibold
                          text-xs sm:text-sm md:text-base
                          transition-all duration-200 shadow-sm hover:shadow-md"
                      >
                        <span className="relative z-10 text-[8px] sm:text-sm">
                          Recent Order Detail
                          {orderTrackerState.count > 1
                            ? `s (${orderTrackerState.count})`
                            : ""}
                        </span>
                      </button>
                    </div>
                  )}

                <button
                  onClick={() => navigate("/profile")}
                  className={`sidebar-profile-button w-full flex items-center justify-center gap-1.5 sm:gap-2
                  rounded-lg px-2 sm:px-3 py-2 sm:py-2.5
                  bg-main/90 hover:bg-main/80 text-white font-semibold
                  ${isDarkMode ? "dm-white-btn" : ""}
                  text-xs sm:text-sm md:text-base
                  transition-all duration-200
                  shadow-sm hover:shadow-md`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <circle
                      cx="12"
                      cy="8"
                      r="4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6"
                    />
                  </svg>
                  <span className="truncate">{user?.name || "Profile"}</span>
                </button>
              </>
            ) : (
              <button
                className={`dm-auth-switch w-full flex items-center justify-center gap-1.5 sm:gap-2
                rounded-lg px-2 sm:px-3 py-2 sm:py-2.5 text-white
                bg-main/90
                font-semibold
                text-xs sm:text-sm md:text-base
                transition-all duration-200
                shadow-sm hover:shadow-md`}
                onClick={() => {
                  setAuthTab("login");
                  setLockAuthToSignup(false);
                  setIsModalOpen(true);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <circle
                    cx="12"
                    cy="8"
                    r="4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                  <path
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6"
                  />
                </svg>
                <span className="truncate">Login</span>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Menu Section */}
      <div
        className="flex-1 overflow-y-auto no-scrollbar relative"
        ref={menuRef}
      >
        <div className="">
          {error && <div className="menu-error">{error}</div>}

          {menuLoading ? (
            <div className="flex items-center justify-center bg-white h-full min-h-[100vh] ">
              <div>
                <VideoLoader size="medium" />
              </div>
            </div>
          ) : Object.keys(groupedMenuItems).length === 0 ? (
            <p className="text-gray-500">No menu items available.</p>
          ) : (
            <>
              <div className="relative">
                <div className="space-y-0">
                  <div className="px-3 sm:px-4 md:px-6 lg:px-9 pt-3 sm:pt-4 md:pt-6 lg:pt-9">
                    {/* Mobile Header */}
                    <div className="sm:hidden flex items-center justify-between mb-4">
                      <div className="h-10 w-auto">
                        {logoUrl ? (
                          <img
                            src={logoUrl}
                            alt="Logo"
                            className="h-full w-auto object-contain"
                          />
                        ) : (
                          <div className="font-bold text-lg">Menu</div>
                        )}
                      </div>

                      <div className="flex items-center gap-2">
                        {user &&
                          orderTrackerState.shouldShow &&
                          orderTrackerState.isMinimized && (
                            <button
                              onClick={() =>
                                orderTrackerRef.current?.handleShow()
                              }
                              className="dm-white-btn flex items-center gap-1.5 px-3 py-2 rounded-full bg-black text-[#ffffff] text-sm font-medium"
                            >
                              <span className="truncate max-w-[60px] text-xs">
                                Orders
                                {orderTrackerState.count > 1
                                  ? ` (${orderTrackerState.count})`
                                  : ""}
                              </span>
                            </button>
                          )}

                        {user ? (
                          <button
                            onClick={() => navigate("/profile")}
                            className={`flex items-center gap-1 px-2 py-2 rounded-full text-xs font-medium bg-main/90 text-white ${
                              isDarkMode ? "dm-white-btn" : ""
                            }`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-3 h-3"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <circle
                                cx="12"
                                cy="8"
                                r="4"
                                strokeWidth="2"
                                fill="none"
                              />
                              <path
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6"
                              />
                            </svg>
                            <span className="truncate max-w-[60px] text-xs">
                              {user?.name || "Profile"}
                            </span>
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              setAuthTab("login");
                              setLockAuthToSignup(false);
                              setIsModalOpen(true);
                            }}
                            className="dm-auth-switch flex items-center gap-2 px-4 py-2 rounded-full bg-main/90 text-white text-sm font-medium"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <circle
                                cx="12"
                                cy="8"
                                r="4"
                                strokeWidth="2"
                                fill="none"
                              />
                              <path
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6"
                              />
                            </svg>
                            Sign In
                          </button>
                        )}
                        <button
                          onClick={() => navigate("/gift-cards")}
                          aria-label="Gift cards"
                          className="flex items-center justify-center h-10 w-10 rounded-full border border-black/5 dm-button-text dm-header-btn bg-white hover:bg-black/5 transition-colors"
                        >
                          <Gift size={18} />
                        </button>
                        <button
                          onClick={() => navigate("/Loyalty")}
                          aria-label="Loyalty"
                          className="flex items-center justify-center h-10 w-10 rounded-full border border-black/5 dm-button-text dm-header-btn bg-white hover:bg-black/5 transition-colors"
                        >
                          <Award size={18} />
                        </button>
                        <ThemeToggle
                          isDarkMode={isDarkMode}
                          onToggle={toggleTheme}
                          rounded="full"
                        />
                      </div>
                    </div>

                    {/* Mobile Restaurant Name */}
                    <div className="sm:hidden text-center mb-3">
                      <h1 className="font-semibold text-[18px] text-gray-900">
                        {restaurantLocation
                          ? restaurantLocation.name
                              .replace(/Fisherman's Wharf Hotel|Hotel/gi, "")
                              .trim() || restaurantLocation.name
                          : "Menu"}
                      </h1>
                    </div>

                    {/* Mobile Address & Time */}
                    {restaurantLocation && (
                      <div className="sm:hidden flex flex-col items-center gap-1 mb-4 text-xs text-gray-600">
                        <div className="flex items-center gap-2">
                          <img
                            src={isDarkMode ? locwhite : loc}
                            alt="loc"
                            className="w-3.5 h-3.5"
                          />
                          <span className="text-center">
                            {restaurantLocation.address}
                          </span>
                        </div>
                        <div
                          className="flex items-center gap-2 cursor-pointer"
                          onClick={() => setIsHotelModalOpen(true)}
                        >
                          <img
                            src={time}
                            alt="time"
                            className="h-3.5 w-3.5 dm-icon-invert"
                          />
                          <span className="font-medium underline">
                            {getTodayOpeningText(restaurantLocation, orderType)}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Desktop Header */}
                    <div className="hidden sm:block mb-4">
                      <h1 className="font-semibold text-[20px] text-gray-900">
                        {restaurantLocation
                          ? restaurantLocation.name
                              .replace(/Fisherman's Wharf Hotel|Hotel/gi, "")
                              .trim() || restaurantLocation.name
                          : "Menu"}
                      </h1>

                      {restaurantLocation && (
                        <>
                          <div className="flex items-center text-xs sm:text-sm text-gray-600 gap-6">
                            <div className="flex items-center gap-2">
                              <img
                                src={isDarkMode ? locwhite : loc}
                                alt="loc"
                                className="w-4 h-4"
                              />
                              <span className="break-words">
                                {restaurantLocation.address}
                              </span>
                            </div>

                            {restaurantLocation && (
                              <div className="flex items-center text-xs sm:text-sm text-gray-600">
                                <div className="flex items-center">
                                  <span className="flex items-center gap-2 cursor-pointer">
                                    <img
                                      src={time}
                                      alt="time"
                                      className="h-4 w-4 dm-icon-invert"
                                    />
                                    <span
                                      className="font-medium underline"
                                      onClick={() => setIsHotelModalOpen(true)}
                                    >
                                      {getTodayOpeningText(
                                        restaurantLocation,
                                        orderType,
                                      )}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {/* Order Type Toggle + Location/Time Controls */}
                    <div className="flex flex-wrap items-center gap-2 mt-2 mb-8">
                      <div className="relative flex bg-white rounded-full p-1 w-full sm:w-auto sm:min-w-[200px] border border-black/20 dm-toggle">
                        <span
                          className={`absolute top-1 bottom-1 rounded-full bg-black dm-toggle-indicator
        transition-all duration-300 ease-out
        ${orderType === "delivery" ? "left-1/2 right-1" : "left-1 right-1/2"}`}
                        />
                        <button
                          onClick={() => {
                            setOrderType("pickup");
                            setIsAddressModalOpen(true);
                          }}
                          className={`relative z-10 flex-1 px-3 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
                            orderType === "pickup"
                              ? "text-white dm-toggle-selected"
                              : "text-black dm-toggle-unselected"
                          } dm-toggle-btn`}
                        >
                          Pickup
                        </button>
                        <button
                          onClick={() => {
                            setOrderType("delivery");
                            setIsAddressModalOpen(true);
                          }}
                          className={`relative z-10 flex-1 px-3 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
                            orderType === "delivery"
                              ? "text-white dm-toggle-selected"
                              : "text-black dm-toggle-unselected"
                          } dm-toggle-btn`}
                        >
                          Delivery
                        </button>
                      </div>

                      {/* Combined Location & Time Button - Mobile Only */}
                      <button
                        onClick={() => setIsAddressModalOpen(true)}
                        className="sm:hidden flex items-center gap-2 px-3 py-2 h-10 rounded-xl border border-black/5 text-sm w-full dm-button-text dm-header-btn
    hover:bg-gray-50 transition-colors"
                      >
                        <Building2 size={18} className="shrink-0" />
                        <div className="flex-1 flex items-center gap-1.5 min-w-0">
                          <span className="truncate">
                            {getLocationDisplayText(true)}
                          </span>
                          <span className="shrink-0">•</span>
                          <span className="truncate">
                            {getTimeDisplayText()}
                          </span>
                        </div>
                        <span className="shrink-0">▾</span>
                      </button>

                      {/* Separate Location Button - Desktop Only */}
                      <button
                        onClick={() => setIsAddressModalOpen(true)}
                        className="hidden sm:flex items-center gap-2 px-3 py-2 h-10 rounded-xl border border-black/5 text-sm dm-button-text dm-header-btn
    flex-1 sm:flex-initial sm:min-w-[160px] sm:max-w-[240px]
    hover:bg-gray-50 transition-colors"
                      >
                        <Building2 size={18} className="shrink-0" />
                        <span className="truncate flex-1 text-left">
                          {getLocationDisplayText(false)}
                        </span>
                        <span className="shrink-0">▾</span>
                      </button>

                      <button
                        onClick={() => setIsTimeModalOpen(true)}
                        className="hidden sm:flex items-center gap-2 px-3 py-2 h-10 rounded-xl border border-black/5 text-sm dm-button-text dm-header-btn
    flex-1 sm:flex-initial sm:min-w-[160px] sm:max-w-[240px]
    hover:bg-gray-50 transition-colors"
                      >
                        <Clock size={18} className="shrink-0" />
                        <span className="truncate flex-1 text-left">
                          {getTimeDisplayText()}
                        </span>
                        <span className="shrink-0">▾</span>
                      </button>

                      <ThemeToggle
                        isDarkMode={isDarkMode}
                        onToggle={toggleTheme}
                        className="hidden sm:flex"
                        showText
                        rounded="xl"
                      />

                      {/* Gift Card + Loyalty - Desktop, pinned right */}
                      <div className="hidden sm:flex items-center gap-2 ml-auto">
                        <button
                          onClick={() => navigate("/gift-cards")}
                          className="flex items-center gap-2 px-3 h-10 rounded-xl border border-black/5 text-sm font-medium dm-button-text dm-header-btn bg-white hover:bg-black/5 transition-colors"
                        >
                          <Gift size={18} className="shrink-0" />
                          Gift Card
                        </button>
                        <button
                          onClick={() => navigate("/Loyalty")}
                          className="flex items-center gap-2 px-3 h-10 rounded-xl border border-black/5 text-sm font-medium dm-button-text dm-header-btn bg-white hover:bg-black/5 transition-colors"
                        >
                          <Award size={18} className="shrink-0" />
                          Loyalty
                        </button>
                      </div>
                    </div>

                    <AddressModals
                      isOpen={isAddressModalOpen}
                      onClose={() => setIsAddressModalOpen(false)}
                      orderType={orderType}
                      setOrderType={setOrderType}
                      selectedLocation={selectedLocation}
                      setSelectedLocation={setSelectedLocation}
                      onScheduleClick={handleScheduleClick}
                      setDeliveryAddress={setDeliveryAddress}
                      setPickupLocation={setPickupLocation}
                      setSelectedAddress={setselectedAddress}
                      onLocationConfirmed={markPickupConfirmed}
                    />
                    <TimePickerModal
                      isOpen={isTimeModalOpen}
                      onClose={() => {
                        setIsTimeModalOpen(false);
                        if (selectedCustomizeItem) {
                          handlecust(selectedCustomizeItem);
                        }
                      }}
                      selectedDate={
                        orderType === "pickup" ? pickupDate : deliveryDate
                      }
                      setSelectedDate={
                        orderType === "pickup" ? setPickupDate : setDeliveryDate
                      }
                      selectedTime={
                        orderType === "pickup" ? pickupTime : deliveryTime
                      }
                      setSelectedTime={
                        orderType === "pickup" ? setPickupTime : setDeliveryTime
                      }
                      selectedLocation={restaurantLocation}
                      orderType={orderType}
                      setSelectedTimemodal={setselectedTimemodal}
                    />

                    <HotelDetailsModal
                      isOpen={isHotelModalOpen}
                      onClose={() => setIsHotelModalOpen(false)}
                      location={restaurantLocation}
                    />
                  </div>

                  {/* Mobile Category Horizontal Scroll */}
                  <div
                    ref={mobileCategoryScrollRef}
                    className="sm:hidden sticky top-0 z-50 bg-white px-3 py-3 overflow-x-auto no-scrollbar  border-b border-gray-100"
                  >
                    <div className="flex gap-2">
                      {categories.map((category) => (
                        <button
                          key={category.name}
                          ref={(el) => {
                            mobileCategoryItemRefs.current[category.name] = el;
                          }}
                          onClick={() => handleCategorySelect(category.name)}
                          className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap
                            ${
                              selectedCategory === category.name
                                ? isDarkMode
                                  ? "dm-white-btn"
                                  : "bg-main/90 text-white"
                                : isDarkMode
                                  ? "dm-category-chip-unselected"
                                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            }`}
                        >
                          {category.name}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Menu Items by Category */}
                  {Object.entries(groupedMenuItems).map(
                    ([categoryName, items], index) => {
                      const isLastCategory =
                        index === Object.keys(groupedMenuItems).length - 1;

                      return (
                        <div
                          key={categoryName}
                          className="category-section"
                          ref={(el) =>
                            (categorySectionRefs.current[categoryName] = el)
                          }
                          data-category-section={categoryName}
                          style={
                            isLastCategory
                              ? { paddingBottom: "0px" }
                              : undefined
                          }
                        >
                          <div
                            ref={(el) => {
                              categoryHeaderRefs.current[categoryName] = el;
                            }}
                            data-category-header={categoryName}
                            className={` sticky top-0 z-20
                          flex items-center justify-between
                          bg-catbg
                          px-4 py-3 sm:px-4 md:px-6 lg:px-10
                          mb-3 sm:mb-4 md:mb-5
                          ${
                            stickyStates[categoryName]
                              ? "bg-catbg max-sm:px-[3px] max-sm:py-2 py-2"
                              : "bg-catbg py-2 md:py-4"
                          }`}
                          >
                            <h2 className=" font-semibold text-gray-900 text-base sm:text-md md:text-md lg:text-lg xl:text-xl 2xl:text-2xl mb-0">
                              {categoryName}
                            </h2>
                          </div>

                          <div
                            className="grid px-3 sm:px-4 md:px-6 lg:px-9
                  gap-2.5 sm:gap-3 md:gap-4 lg:gap-6
                  grid-cols-1 md:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3
                 mb-4"
                          >
                            {items.map((item) => {
                              const getTotalItemQty = (itemId: string) =>
                                cart
                                  .filter((c) => c.itemId === itemId)
                                  .reduce((total, c) => total + c.quantity, 0);

                              const totalQty = getTotalItemQty(item._id);

                              return (
                                <button
                                  key={item._id}
                                  data-item-id={item._id}
                                  data-item-category={item.category}
                                  className="bg-white rounded-[20px] sm:rounded-[30px] cursor-pointer flex sm:gap-3 md:gap-4 lg:gap-6
                                   p-[15px] border border-black/5"
                                  type="button"
                                  onClick={() => handleMenuItemSelect(item)}
                                >
                                  <div className="flex-1 flex flex-col justify-center gap-1 sm:gap-1.5 md:gap-2 min-w-0">
                                    <div className="mb-2 gap-1">
                                      <h3 className="text-[18px] mb-1 font-semibold text-black m-0 text-left">
                                        {item.name}
                                      </h3>
                                      <div className="flex items-center m-0 ">
                                        <span className="text-[18px] font-semibold text-black">
                                          {currencySymbol}{item.price.toFixed(2)}
                                        </span>
                                      </div>
                                    </div>
                                    <p
                                      className="text-[13px] font-normal text-black/60 m-0 line-clamp-2  sm:block text-left"
                                    >
                                      {item.description
                                        ? item.description
                                            .split(" ")
                                            .slice(0, 10)
                                            .join(" ") +
                                          (item.description.split(" ").length >
                                          10
                                            ? "..."
                                            : "")
                                        : ""}
                                    </p>
                                  </div>

                                  <div className="flex-shrink-0">
                                    <div className="relative">
                                      <div
                                       className="h-28 w-28 sm:h-24 sm:w-24 md:h-28 md:w-28 lg:h-32 lg:w-32
   flex items-center justify-center rounded-[25px]">
                                        <img
                                          src={
                                            item.imageUrl || "/placeholder.png"
                                          }
                                          alt={item.name}
                                          className="h-full w-full rounded-[10px] sm:rounded-[12px] md:rounded-[15px]
                                  object-cover"
                                          onError={(e) => {
                                            e.currentTarget.src =
                                              "/placeholder.png";
                                          }}
                                        />
                                      </div>

                                      {item.foodType !== "both" && (
                                        <img
                                          src={
                                            item.foodType === "veg"
                                              ? vegIcon
                                              : nonvegIcon
                                          }
                                          alt={item.foodType}
                                          className="absolute -top-[10px] -right-[5px] sm:-top-[12px] sm:-right-[6px]
                                  md:-top-[13px] md:-right-[10px]
                                  w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4"
                                        />
                                      )}

                                      <div
                                        className="flex justify-center items-center absolute
                              -bottom-2 sm:-bottom-2.5 md:-bottom-3 left-0 right-0 mx-auto"
                                      >
                                        {totalQty === 0 ? (
                                          <button
                                            className="add-button dm-white-btn border-[0.8px] border-black/20 px-2 py-0.5 sm:px-2.5 sm:py-1 md:px-3 md:py-1
                                          rounded-[5px] sm:rounded-[6px] md:rounded-[8px] bg-white w-16
                                          text-[11px] sm:text-[13px] lg:text-[15px]
                                          font-semibold shadow-md"
                                            onClick={(e) =>
                                              handleAddButtonClick(item, e)
                                            }
                                          >
                                            Add +
                                          </button>
                                        ) : (
                                          <div
                                            className="flex dm-white-btn items-center justify-between gap-1.5 bg-white  rounded-[5px] sm:rounded-[6px] md:rounded-[8px] w-16 border border-black/30 shadow-md"
                                            onClick={(e) =>
                                              e.stopPropagation()
                                            }
                                            role="group"
                                            aria-label={`Quantity controls for ${item.name}`}
                                          >
                                            <button
                                              className=" w-5 h-5 rounded-[10px] font-bold cursor-pointer flex items-center justify-center"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                const allItemVariants =
                                                  cart.filter(
                                                    (c) =>
                                                      c.itemId === item._id,
                                                  );
                                                if (
                                                  allItemVariants.length === 0
                                                )
                                                  return;
                                                const lastVariant =
                                                  allItemVariants[
                                                    allItemVariants.length - 1
                                                  ];
                                                if (
                                                  lastVariant.quantity <= 1
                                                ) {
                                                  removeFromCart(
                                                    lastVariant.cartId,
                                                  );
                                                } else {
                                                  updateQuantity(
                                                    lastVariant.cartId,
                                                    lastVariant.quantity - 1,
                                                  );
                                                }
                                              }}
                                            >
                                              −
                                            </button>
                                            <span className="text-[11px] sm:text-[13px] lg:text-[15px] ">
                                              {String(totalQty)}
                                            </span>
                                            <button
                                              className=" w-5 h-5 rounded-[10px] border-none font-bold cursor-pointer flex items-center justify-center"
                                              onClick={(e) =>
                                                handleAddButtonClick(item, e)
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className=" flex justify-center items-center mx-auto mt-3" />
                                  </div>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Cart Toggle Button (mobile) */}
      {!isCartOpen && (
        <button
          className={`dm-cart-btn dm-white-btn flex items-center gap-2 fixed
 right-[max(20px,env(safe-area-inset-right,20px))]
 bottom-[max(20px,env(safe-area-inset-bottom,20px))]
 px-[14px] py-[12px]
text-sm
 rounded-full
 bg-main/90
  font-semibold
 border-0
 z-[1000]
 text-white
 cursor-pointer ${isCartHeartbeatActive ? "dm-cart-btn-heartbeat" : ""}`}
          aria-controls="cart"
          aria-expanded={isCartOpen}
          aria-label="Open cart"
          onClick={toggleCart}
        >
          <ShoppingCart height={"17px"} width={"17px"} /> Cart ({totalItems})
        </button>
      )}

      {/* Overlay */}
      <div
        role="presentation"
        aria-hidden={!isCartOpen}
        className={`fixed inset-0 bg-black/50 z-[98]  ${
          isCartOpen ? "block" : "hidden"
        }`}
        onClick={closeCart}
      />

      {/* Cart Panel */}
      <CartPanel
        isOpen={isCartOpen}
        cart={cart}
        menuItems={menuItems}
        appliedDeals={appliedDeals}
        subtotal={subtotal}
        totalDealDiscount={totalDealDiscount}
        discountAmount={discountAmount}
        grandTotal={grandTotal}
        loading={loading}
        onClose={closeCart}
        onClearCart={() => setClearCartConfirmOpen(true)}
        onUpdateQuantity={updateQuantity}
        onRemoveFromCart={removeFromCart}
        onRemoveDeal={removeDealFromCart}
        onCheckout={handleCheckout}
        onEditCartItem={(cartItem) => {
          const menuItem = menuItems.find((m) => m._id === cartItem.itemId);
          setCustomizingItem(cartItem);
          setSelectedCustomizeItem(menuItem || null);
          setSpecialRequests(cartItem.requestedCustomization || "");
          const populated = buildSelectionsFromOptions(
            menuItem,
            cartItem.customOptions || [],
          );
          setCustomSelections(populated);
          setShowcustModal(true);
        }}
        onCustomizeItem={handlecust}
        onAddDirectItem={(item) => {
          const newCartItem = {
            cartId: `${item._id}-${Date.now()}`,
            itemId: item._id,
            name: item.name,
            kitchenName: item.kitchenName,
            price: item.price,
            quantity: 1,
            imageUrl: item.imageUrl,
            customOptions: [],
            isPartOfDeal: false,
            categoryId: resolveCategoryCode(item) ?? item.categoryId ?? "",
          };
          setOrderData((prev: any) => {
            if (!prev) return prev;
            return { ...prev, items: [...(prev.items || []), newCartItem] };
          });
        }}
        getDisplayAddedOptions={getDisplayAddedOptions}
        itemHasCustomizations={itemHasCustomizations}
      />

      {/* Item Detail Modal */}
      {selectedItem && (
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          dialogClassName="flex items-center justify-center min-h-screen"
          contentClassName="border-2 !border-black/30 rounded-[20px] bg-white
                  p-3 shadow-[0_6px_18px_rgba(0,0,0,0.12)]
                max-w-[350px]"
        >
          <Modal.Header
            className="absolute top-2.5 right-2.5 z-10 border-b-0 p-0 text-black"
            closeButton
          />
          <Modal.Body>
            <img
              src={selectedItem.imageUrl || "/placeholder.png"}
              alt={selectedItem.name}
              className="w-full max-h-[220px] object-cover rounded-[15px] block"
              onError={(e) => {
                e.currentTarget.src = "/placeholder.png";
              }}
            />
            <h3 className="font-bold text-lg   text-black mb-[10px] text-left mt-4">
              {selectedItem.name}
            </h3>
            <p className="text-xs text-black font-normal   h-auto overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] text-left mt-4">
              {selectedItem.description}
            </p>
            <div className="flex justify-between items-center gap-[10px] mt-5 ">
              <span className="font-bold text-[22px]">
                {currencySymbol}{selectedItem.price.toFixed(2)}
              </span>
              {getItemQty(selectedItem._id) === 0 ? (
                <button
                  className="bg-white border-none py-1.5 sm:py-2 px-3 sm:px-[14px] rounded-[8px] sm:rounded-[10px]
font-semibold cursor-pointer text-[11px] sm:text-[12px] md:text-[13px] text-black"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedItem) {
                      handlecust(selectedItem);
                      handleCloseModal();
                    }
                  }}
                >
                  Add +
                </button>
              ) : (
                <div
                  className="inline-flex items-center gap-[6px] bg-white py-[2px] px-[6px]"
                  role="group"
                  aria-label={`Quantity controls for ${selectedItem.name}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="bg-white text-black border-none w-5 h-5 rounded-[5px]
                   cursor-pointer flex items-center justify-center"
                    aria-label={`Decrease quantity of ${selectedItem.name}`}
                    onClick={() => {
                      const current = getItemQty(selectedItem._id);
                      if (current <= 1) {
                        removeFromCart(selectedItem._id);
                      } else {
                        updateQuantity(selectedItem._id, current - 1);
                      }
                    }}
                  >
                    −
                  </button>
                  <span className="w-5 text-center font-bold">
                    {String(getItemQty(selectedItem._id)).padStart(2, "0")}
                  </span>
                  <button
                    className="bg-white text-black border-none w-5 h-5 rounded-[5px]
                   cursor-pointer flex items-center justify-center"
                    aria-label={`Increase quantity of ${selectedItem.name}`}
                    onClick={() =>
                      updateQuantity(
                        selectedItem._id,
                        getItemQty(selectedItem._id) + 1,
                      )
                    }
                  >
                    +
                  </button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* Customize Modal */}
      {/* BYO pizza picker — shown when deal has multiple eligible pizzas */}
      {byoPicker && activeBYODeal && (
        <div className="fixed inset-0 z-[9998] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden">
            <div className="p-4 border-b border-gray-100">
              <div className="flex items-start justify-between">
                <div>
                  <h2 className="font-black text-lg text-gray-900">{activeBYODeal.dealName}</h2>
                  <p className="text-sm text-gray-500 mt-0.5">
                    Pizza {byoPicker.pizzaIndex + 1} of {activeBYODeal.minPizzas} — Choose your pizza
                  </p>
                </div>
                <button
                  onClick={() => {
                    setByoPicker(null);
                    setOrderData((prev: any) => ({
                      ...prev,
                      items: (prev?.items || []).filter((i: any) => i.dealId !== activeBYODeal.claimId),
                      appliedDeals: (prev?.appliedDeals || []).filter((d: any) => d.claimId !== activeBYODeal.claimId),
                    }));
                    setActiveBYODeal(null);
                  }}
                  className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition"
                >
                  <span className="text-xl font-bold">✕</span>
                </button>
              </div>
              {activeBYODeal.includedToppings > 0 && (
                <div className="mt-2 px-3 py-1.5 bg-blue-50 border border-blue-100 rounded-lg">
                  <p className="text-xs text-blue-700 font-medium">
                    First {activeBYODeal.includedToppings} toppings free · Extra toppings at menu price
                  </p>
                </div>
              )}
            </div>
            <div className="p-4 max-h-[60vh] overflow-y-auto">
              <div className="grid grid-cols-2 gap-3">
                {activeBYODeal.itemIds.map((itemId) => {
                  const item = menuItems.find((m) => m._id === itemId);
                  if (!item) return null;
                  return (
                    <button
                      key={itemId}
                      onClick={() => {
                        setByoPicker(null);
                        setSelectedCustomizeItem(item);
                        setShowcustModal(true);
                      }}
                      className="flex flex-col items-center bg-gray-50 hover:bg-orange-50 border-2 border-gray-200 hover:border-orange-400 rounded-xl p-3 transition-all duration-200 text-left group"
                    >
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.name} className="w-full h-24 object-cover rounded-lg mb-2" />
                      ) : (
                        <div className="w-full h-24 bg-gray-200 rounded-lg mb-2 flex items-center justify-center text-gray-400 text-3xl">🍕</div>
                      )}
                      <span className="font-semibold text-sm text-gray-900 text-center leading-tight group-hover:text-orange-500">
                        {item.name}
                      </span>
                      <span className="text-xs text-gray-500 mt-1">{currencySymbol}{activeBYODeal.basePrice.toFixed(2)}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      <CustomizeModal
        isOpen={showcustModal}
        selectedCustomizeItem={selectedCustomizeItem}
        customizingItem={customizingItem}
        customSelections={customSelections}
        specialRequests={specialRequests}
        attemptedSubmit={attemptedSubmit}
        collapsedGroups={collapsedGroups}
        cart={cart}
        menuItems={menuItems}
        missingRequiredGroupName={missingRequiredGroupName}
        customizeGroupRefs={customizeGroupRefs}
        onClose={closeCustomizeModal}
        onChoiceChange={handleChoiceChange}
        onHalfHalfSelection={handleHalfHalfSelection}
        onCustomSubmit={handleCustomSubmit}
        onSpecialRequestsChange={setSpecialRequests}
        onAttemptedSubmitChange={setAttemptedSubmit}
        onCollapsedGroupsChange={setCollapsedGroups}
        onGoToNextGroup={goToNextCustomizationGroup}
        onScrollToMissingGroup={scrollToMissingRequiredGroup}
        setCustomSelections={setCustomSelections}
        onAddCrossItem={handlecust}
        resolveCategoryCode={resolveCategoryCode}
        setOrderData={setOrderData}
        activeBundleDeal={activeBundleDeal}
        activeBYODeal={activeBYODeal}
        onSwitchBundleOption={switchBundleOption}
      />

      {/* Auth Modal */}
      {isModalOpen && (
        <AuthModal
          isOpen={isModalOpen}
          activeTab={authTab}
          lockToSignup={lockAuthToSignup}
          onSignupSuccess={() => {
            clearPendingSignupCode();
            clearSignupParamsFromUrl();
            setLockAuthToSignup(false);
          }}
          onClose={() => setIsModalOpen(false)}
        />
      )}

      {/* Confirm Remove Modal */}
      <ConfirmModal
        open={confirmModal.open}
        title={confirmModal.isDeal ? "Remove Deal?" : "Remove Item?"}
        message={
          confirmModal.isDeal
            ? `This will remove the entire deal "${confirmModal.itemName}"${confirmModal.itemCount ? ` (${confirmModal.itemCount} items)` : ""} from your cart. Continue?`
            : `Are you sure you want to remove "${confirmModal.itemName}" from your cart?`
        }
        onConfirm={handleConfirmRemove}
        onCancel={() => setConfirmModal({ open: false })}
      />

      {/* Confirm Clear Cart Modal */}
      <ConfirmModal
        open={clearCartConfirmOpen}
        title="Clear Cart?"
        message="Are you sure you want to remove all items from your cart?"
        onConfirm={() => {
          setOrderData((prev) => ({ ...prev, items: [] }));
          setClearCartConfirmOpen(false);
        }}
        onCancel={() => setClearCartConfirmOpen(false)}
      />

      {/* Repeat Custom Modal */}
      {repeatModalItem && (
        <RepeatCustomModal
          show={showRepeatModal}
          onHide={() => {
            setShowRepeatModal(false);
            setRepeatModalItem(null);
          }}
          itemName={repeatModalItem.name}
          existingCartItems={cart.filter(
            (c) => c.itemId === repeatModalItem._id,
          )}
          onRepeat={handleRepeatOrder}
          onCustomize={() => {
            setShowRepeatModal(false);
            handlecust(repeatModalItem);
            setRepeatModalItem(null);
          }}
          updateQuantity={updateQuantity}
        />
      )}

      {/* Global Order Tracker */}
      {user && (
        <OrderTracker
          ref={orderTrackerRef}
          phoneNumber={user.phonenumber || ""}
          pollingInterval={8000}
          renderButton={false}
          onStateChange={handleOrderTrackerStateChange}
        />
      )}
    </div>
  );
};

export default POS;
